<template>


    <div class="vote-screen"
         :class="{compact: getPlaceLinks() && getPlaceLinks().length > 0,
        stretched: !getPlaceLinks() || getPlaceLinks().length == 0}">
        <giveawayModal :settings="giveawayModalSettings"></giveawayModal>
        <snapPicturePopup :settings="snapPicturePopupSettings"></snapPicturePopup>
        <serviceLogInformPopup :settings="serviceInfoModalSettings"></serviceLogInformPopup>
        <explainGeolactionPopup :settings="explainGeolocationPopupSettings"></explainGeolactionPopup>
        <geolocationLoadingPopup :settings="geolocationLoadingPopupSettings"></geolocationLoadingPopup>
        <publicReviewPopup :settings="publicReviewPopupSettings"></publicReviewPopup>
        <googleAutoReviewPopup :settings="googleAutoReviewPopupSettings" ref="gAutoReviewPopup"></googleAutoReviewPopup>
        <staffLoginModal :settings="staffLogInModalSettings"></staffLoginModal>
        <div class="wrapper" v-if="this.checkSecondLevelDetails() || this.serviceLogMode"
             v-bind:style="{ filter: [signInLoading ? 'blur(2px)' : 'none'], background: [this.getBlocksScreenBackground()]}">
            <profileIcon :settings="profileIconSettings" ic_color="#ffffff"></profileIcon>
            <div v-if="testTemplateBlocksEnabled" style="height: 70px; background-color: #6D6D6D; width: 100%;"></div>
            <div class="header"
            :style="{'background':`${getBlocksScreenPrimaryColor()}`,
            'color': `#ffffff`,}">
                <div class="header__wrapper">
                    <div class="header-title">{{getTranslations(getBlocksScreenTitle())}}</div>
                </div>
                <div class="sld_subtitle" v-if="getSldSubtitle()">{{ getSldSubtitle() }}</div>
            </div>
            <div class="location" v-if="accessToken && checkShowPlacementFlag()">
                <div class="location_wrapper">
                    <div class="placement">
                        <input :placeholder="this.translate('Placement')" id="placement" type="text" v-model="newPlacement"
                               :style="{ 'border-bottom': `2px solid ${getBlocksScreenPrimaryColor()}`,
                                          'color': `${getBlocksScreenPrimaryColor()}`,}">
                    </div>
                    <div class="update_location-btn" @click="updatePlacementBtnClick" :class="{disabled: newPlacement == place_info.placement}"
                         :style="{'background':`${getBlocksScreenPrimaryColor()}`,}">
                        {{ translate('Update') }}
                    </div>
                </div>
            </div>
            <div class="main-content" style="flex-flow: wrap;">
                <div class="content__wrapper" v-for="(index) in Math.ceil(this.rectangles.length / 2)"  :key="index">
                    <div class="rectangle-wrapper left">
                        <div class="rectangle" :class="{active: rectangles[index * 2 - 2].active}"
                             :style="{ 'background': `${getRectBackground(index * 2 - 2)}`, }"
                             @click="onRectClick(rectangles[index * 2 - 2], index * 2 - 2)">
                            <div v-if="showShowSldUserImage(index * 2 - 2) && !isSldUserFileUploading(index * 2 - 2)" class="rect_close_back"
                                 :style="{ 'background': showShowSldUserImage(index * 2 - 2) ? `${getBlocksScreenPrimaryColor()}54` : 'none',}"></div>
                            <img v-if="rectangles[index * 2 - 2].active && !isSldUserFileUploading(index * 2 - 2)" class="rect_close"
                                 src="@/assets/icons/rect_close_img.png" v-on:click.stop="onRectCloseClick(rectangles[index * 2 - 2], index * 2 - 2)">
                            <inline-svg :src="getSldIcons(rectangles[index * 2 - 2].icon, rectangles[index * 2 - 2].active)"
                                        v-if="rectangles[index * 2 - 2].icon && !rectangles[index * 2 - 2].active"
                                        :fill="getBlocksScreenPrimaryColor()"  class="rectangle_img" />
                            <img v-if="rectangles[index * 2 - 2].active && !getSldUserImage(index * 2 - 2)" class="rect_btn_img"
                                 src="@/assets/icons/photo_btn_img.png">
                            <div class="progress_loader_wrapper"
                                 v-if="showShowSldUserImage(index * 2 - 2) && getSldUserFile(index * 2 - 2).isUploading"
                                 :style="{ 'background': `${getBlocksScreenPrimaryColor()}54`,}"><div class="progress_loader"/></div>
                            <div :class="{active: rectangles[index * 2 - 2].active,
                            'rectangle-text': rectangles[index * 2 - 2].icon || rectangles[index * 2 - 2].active,
                            'rectangle-text__noicon': !rectangles[index * 2 - 2].icon && !rectangles[index * 2 - 2].active,
                            }"
                                 :style="{ 'background': showShowSldUserImage(index * 2 - 2) ? `${getBlocksScreenPrimaryColor()}54` : 'none',
                                  'max-width': showShowSldUserImage(index * 2 - 2) ? `80%` : '96%',
                                   'color': getRectLblColor(index * 2 - 2), }">
                                {{ getTranslations(rectangles[index * 2 - 2].text) }}
                            </div>
                        </div>
                    </div>
                    <div class="rectangle-wrapper right" v-if="index * 2 - 1 < rectangles.length">
                        <div class="rectangle" :class="{active: rectangles[index * 2 - 1].active}"
                             :style="{ 'background': `${getRectBackground(index * 2 - 1)}`, }"
                             @click="onRectClick(rectangles[index * 2 - 1], index * 2 - 1)">
                            <div v-if="showShowSldUserImage(index * 2 - 1) && !isSldUserFileUploading(index * 2 - 1)" class="rect_close_back"
                                 :style="{ 'background': showShowSldUserImage(index * 2 - 1) ? `${getBlocksScreenPrimaryColor()}54` : 'none',}"></div>
                            <img v-if="rectangles[index * 2 - 1].active && !isSldUserFileUploading(index * 2 - 1)" class="rect_close"
                                 src="@/assets/icons/rect_close_img.png" v-on:click.stop="onRectCloseClick(rectangles[index * 2 - 1], index * 2 - 1)">
                            <inline-svg :src="getSldIcons(rectangles[index * 2 - 1].icon, rectangles[index * 2 - 1].active)"
                                        v-if="rectangles[index * 2 - 1].icon && !rectangles[index * 2 - 1].active"
                                        :fill="getBlocksScreenPrimaryColor()"  class="rectangle_img" />
                            <img v-if="rectangles[index * 2 - 1].active && !getSldUserImage(index * 2 - 1)" class="rect_btn_img"
                                 src="@/assets/icons/photo_btn_img.png">
                            <div class="progress_loader_wrapper"
                                 v-if="showShowSldUserImage(index * 2 - 1) && getSldUserFile(index * 2 - 1).isUploading"
                                 :style="{ 'background': `${getBlocksScreenPrimaryColor()}54`,}"><div class="progress_loader"/></div>
                            <div :class="{active: rectangles[index * 2 - 1].active,
                            'rectangle-text': rectangles[index * 2 - 1].icon || rectangles[index * 2 - 1].active,
                            'rectangle-text__noicon': !rectangles[index * 2 - 1].icon && !rectangles[index * 2 - 1].active,
                            }"
                                 :style="{ 'background': showShowSldUserImage(index * 2 - 1) ? `${getBlocksScreenPrimaryColor()}54` : 'none',
                                  'max-width': showShowSldUserImage(index * 2 - 1) ? `80%` : '96%',
                                   'color': getRectLblColor(index * 2 - 1), }">
                                {{ getTranslations(rectangles[index * 2 - 1].text) }}
                            </div>
                        </div>
                    </div>
                    <div class="rectangle-wrapper right" v-else>

                    </div>
                </div>
                <div class="comment-wrap" style="margin-left: 16px; margin-right: 16px;"
                     :style="{ 'padding-bottom': needShowWantToHearBackBlock() ? '0px' : '12px' }"
                     v-if="this.rectangles.filter(item => item.active).length > 0 || getCurrentBlocksConfig().show_comment_always">
                    <div class="commentTextarea__wrapper">
                        <div class="commentTextarea upInputs">
                            <div class="comment_wrapper small">
                                <recordAudioBtn :settings="recordAudioBtnSettings"></recordAudioBtn>
                                <div @click="onAttachClick" v-if="true" class="comment_btn__wrapper photo"
                                     :style="{ opacity: [files.length == maxFiles ? '0.2' : '1']}">
                                    <inline-svg :src="require('@/assets/icons/ic_photo.svg')"
                                                :fill="getBlocksScreenPrimaryColor()"/>
                                </div>
                                <textarea :placeholder="translate('addYourNote')" id="comment__textarea-second"
                                          name="comment__textarea"
                                          class="form__input" v-model="commentText"
                                          :maxlength="200"
                                          @input="autoGrowTextArea"
                                          :style="{ 'padding-bottom': smallCommentTextAreaPaddingBottom,
                                          'border-bottom': `2px solid ${getBlocksScreenPrimaryColor()}`,
                                          'max-height': `none`,
                                          'color': `${getBlocksScreenPrimaryColor()}`,}"
                                           required></textarea>
                                <div @click="onSaveComment()" class="comment_btn__wrapper send"
                                     :style="{ 'opacity': commentText != '' || hasCommentImages() || this.recordedAudio.length > 0 || this.recordInProgress ? 1 : 0.5 }">
                                    <inline-svg :src="require('@/assets/icons/ic_send.svg')"
                                                :fill="getBlocksScreenPrimaryColor()"/>
                                </div>
                            </div>
                            <input
                                style="display: none"
                                type="file"
                                @change="onFileSelected"
                                ref="fileInput"
                                accept="image/png, image/jpeg">
                            <input
                                style="display: none"
                                type="file"
                                @change="onFileSelected"
                                ref="fileInputOnlyPhoto"
                                accept="image/png, image/jpeg"
                                capture="camera">
                        </div>
                        <div class="preview" v-if="hasCommentImages()">
                            <img v-for="(item, index) in files"
                                 :key="index"
                                 :src="item.url"
                                 @click="onFileClick(item)"/>
                        </div>
                    </div>
                    <div class="audio_wrapper" id='audio' v-for="(item, index) in recordedAudio" :key="index">
                        <img :src="item.url"/>
                        <div class="audio_delete" id="audio_delete" v-if="recordedAudio.length > 0"
                             @click="deleteAudioClick">
                            <img src="@/assets/icons/ic_trash.svg" alt="">
                        </div>
                        <audio controls='controls' v-if="recordedAudio.length > 0">
                            <source :src="audioLink">
                        </audio>
                    </div>
                    <div class="feedback-wrapper" v-if="needShowWantToHearBackBlock()"
                    :style="{ 'background': 'none', 'padding-left': 0, 'padding-top': '4px',}">
                        <div class="feedbackCheckbox-wrapper" @click="feedbackBlock = !feedbackBlock">
                            <inline-svg :src="require('@/assets/icons/ic_checkbox_checked.svg')" :fill="getBlocksScreenPrimaryColor()"
                            v-if="feedbackBlock"/>
                            <inline-svg :src="require('@/assets/icons/ic_checkbox.svg')" :fill="getBlocksScreenPrimaryColor()"
                            v-else/>
                            <label>
                                <div>
                                    <span class="feedback-text"
                                          :style="{ 'color': getBlocksScreenPrimaryColor(), }">{{ getWantToHearBackText() }}</span>
                                </div>
                            </label>
                        </div>
                        <div class="feedback-input" v-if="feedbackBlock == true">
                            <div class="feedback-buttons__wrapper" v-if="!this.isAuthorized">
                                <div class="feedback-buttons">
                                    <div class="feedback-buttons__google" @click="onGoogleSingIn">
                                        <img src="@/assets/icons/ic_google_logo.svg">
                                    </div>
                                    <div class="feedback-buttons__facebook" @click="onFacebookSignIn">
                                        <img src="@/assets/icons/ic_facebook_logo.svg">
                                    </div>
                                    <v-facebook-login @sdk-init="sdkLoaded" app-id="770275700057951"
                                                      hidden></v-facebook-login>
                                </div>
                                <span :style="{'color': getBlocksScreenPrimaryColor(),}">
                                        {{ translate('feedbackTextOr') }}
                                    </span>
                            </div>
                            <div class="commentTextarea" style="align-self: end; margin-bottom: 1px;">
                                <input :placeholder="translate('commentPopupEmail')" class="feedback__input"
                                       :style="{ 'background': 'none',
                                       'color': getBlocksScreenPrimaryColor(),
                                       'border-bottom': `2px solid ${getBlocksScreenPrimaryColor()}`,
                                       'border-radius': `0`, }"
                                       v-model="feedbackEmailValue">
                            </div>
                        </div>
                    </div>
                    <div v-else class="feedback-wrapper-spacer"></div>
                    <div class="socialReview-btn"
                         v-if="anonComment == true && rate_id == 3 && (getPlaceLinks() && getPlaceLinks().length > 0)"
                         @click="anonComment = false">
                        <div class="socialReview-btn-text">{{ translate('reviewSocialOr') }}</div>
                    </div>
                </div>
                <div class="block-btn__wrapper giveaway" @click="onOpenGiveawayClick" v-if="giveaway.enabled"
                style="margin-top: 16px;">
                    <div class="block-btn giveaway m_and_k" :class="{active: giveaway.participates, m_and_k: giveaway.giveaway_title == 'm&k'}">
                        <div class="giveaway-text__wrapper" v-if="!giveaway.participates">
                            <div v-if="giveaway.giveaway_title == 'jbar'">
                                <div class="giveaway-text">{{ translate('ambassadorBtn_title') }}</div>
                                <div class="giveaway-text">{{ translate('ambassadorBtn_subtitle') }}</div>
                            </div>
                            <div v-if="giveaway.giveaway_title == 'm&k'">
                                <div class="giveaway-text">JOIN M&K GIVEAWAY CONTEST</div>
                            </div>
                            <div v-if="giveaway.giveaway_title == 'wasted'">
                                <div class="giveaway-text">JOIN WASTED* GIVEAWAY CONTEST</div>
                            </div>
                        </div>
                        <div class="giveaway-text__wrapper" v-else>
                            <div v-if="giveaway.giveaway_title == 'jbar'">
                                <div class="giveaway-text">{{ translate('welcomeAmbassador') }}</div>
                            </div>
                            <div v-if="giveaway.giveaway_title == 'm&k'">
                                <div class="giveaway-text">YOUR M&K GIVEAWAY</div>
                                <div class="giveaway-text">CONTEST RULES</div>
                            </div>
                            <div v-if="giveaway.giveaway_title == 'wasted'">
                                <div class="giveaway-text">YOUR WASTED* GIVEAWAY</div>
                                <div class="giveaway-text">CONTEST RULES</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.showServiceLogInfoPopup" class="service_log_info" @click="onServiceInfoClick">
                <div class="service_log_info_wrapper">
                    <img src="@/assets/icons/clipboard-text-clock.svg" alt="">
                    <div class="service_log_info__text">
                        {{translate('serviceLogInfoBtn')}}
                    </div>
                </div>
            </div>
            <div v-if="testTemplateBlocksEnabled"
                 style="height: 44px; background-color: #6D6D6D; width: 100%; bottom: 0"></div>
            <div class="bottom_picture_block pct_slide_up" :class="{pct_slide_down: showBottomSnapPictureBlock}" @click="onAttachBottomBlockClick()"><div class="bottom_picture_content"><span class="lbl">{{bottomSnapPictureBlockText()}}</span><img class="bottom_picture_img" src="@/assets/icons/ic_camera_add.svg"/></div></div>
        </div>
        <div
            v-bind:class="' face-rate' + ' option-' + rate_id + [rate_id ? ' selected' : '']"
            v-bind:style="{ filter: [signInLoading ? 'blur(2px)' : 'none']}"
            v-else
        >
            <profileIcon :settings="profileIconSettings"></profileIcon>
            <div v-if="testTemplateBlocksEnabled" style="height: 70px; background-color: #6D6D6D; width: 100%;"></div>
            <div class="block__wrapper">
                <div class="top-block">
                    <div class="logo" @click="onAirVoteLogoClick">
                        <img alt="logo" src="../assets/icons/logo_mini.svg" class="bad">
                    </div>

                    <div class="place">
                        <div class="place_img" @click="onPlaceImageClick()">
                            <img v-if="place_img.length != 0" :src="place_img" alt="place img">
                            <img v-else src="../assets/re/default_place_img.jpg" alt="place img">
                        </div>
                    </div>
                    <div class="place_name" @click="onPlaceNameClick()">{{ place_info.place.name }}</div>
                    <div class="question" @click="onQuestionNameClick()">{{ place_info.question }}</div>

                    <div class="push_rate">
                        <ul v-bind:class="[sendRateClass ? 'disable-class' : '']">
                            <li v-bind:class="'cool ' + [rate_id == '3' ? 'active' : '']"
                                v-if="!isDumpstersMode()">
                                <a @click="changeRateRote(3)">
                                    <img alt="logo" src="../assets/re/smile/cool.png">
                                </a>
                            </li>
                            <li v-bind:class="'soso ' + [rate_id == '2' ? 'active' : '']" v-if="showYellowSmiley">
                                <a @click="changeRateRote(2)">
                                    <img alt="logo" src="../assets/re/smile/soso.png">
                                </a>
                            </li>
                            <li v-bind:class="'meh ' + [rate_id == '1' ? 'active' : '']">
                                <a @click="changeRateRote(1)">
                                    <img alt="logo" src="../assets/re/smile/meh.png">
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="success-message" v-if="!(phoneWindowSizeSE && feedbackBlock)">
                        <div class="success-text">{{ translate('voteSuccessText_1') }}</div>
                        <div class="success-text m-k" v-if="giveaway && giveaway.enabled && giveaway.giveaway_title == 'm&k'">Join our giveaway contest below to win $150 cash</div>
                    </div>
                    <div class="comment-modal__btn">
                        <div class="comment-wrap">
                            <h2 class="note-title" v-if="anonComment == true">{{ translate('anonComment') }}:</h2>
                            <h2 class="note-title" v-else>{{
                                    getMainScreenNoteTitle()
                                }}</h2>
                            <div class="commentTextarea__wrapper">
                                <div class="commentTextarea upInputs">
                                    <div class="comment_wrapper small">
                                        <div @click="onAttachClick" v-if="true" class="comment_btn__wrapper photo"
                                             :style="{ opacity: [files.length == maxFiles ? '0.2' : '1']}">
                                            <inline-svg :src="require('@/assets/icons/ic_photo.svg')"
                                                        fill="#424242"/>
                                        </div>
                                        <recordAudioBtn :settings='recordAudioBtnSettings'></recordAudioBtn>
                                        <textarea :placeholder="translate('yourNote')" id="comment__textarea"
                                                  name="comment__textarea"
                                                  @input="autoGrowTextArea"
                                                  class="form__input" v-model="commentText" :maxlength="maxCommentLength"
                                                  :style="{ 'padding-bottom': smallCommentTextAreaPaddingBottom,}"
                                                  required></textarea>
                                        <div @click="onSaveComment()" class="comment_btn__wrapper send"
                                             :style="{ 'opacity': commentText != '' || hasCommentImages() || this.recordedAudio.length > 0 || this.recordInProgress ? 1 : 0.5 }">
                                            <inline-svg :src="require('@/assets/icons/ic_send.svg')"
                                                        fill="#424242"/>
                                        </div>
                                    </div>
                                    <div class="comment_wrapper big" id="comment_wrapper_big">
                                        <textarea :placeholder="translate('yourNote')" id="comment__textarea_big"
                                                  name="comment__textarea"
                                                  class="form__input" v-model="commentText" @input="autoGrowTextArea"
                                                  @focusout="onCommentBigFieldFocusOut" :maxlength="maxCommentLength" required
                                                  rows="1"></textarea>
                                    </div>
                                    <input
                                        style="display: none"
                                        type="file"
                                        @change="onFileSelected"
                                        ref="fileInput"
                                        accept="image/png, image/jpeg">
                                    <input
                                        style="display: none"
                                        type="file"
                                        @change="onFileSelected"
                                        ref="fileInputOnlyPhoto"
                                        accept="image/png, image/jpeg"
                                        capture="camera">
                                </div>
                                <div class="preview" v-if="hasCommentImages()">
                                    <img v-for="(item, index) in files"
                                         :key="index"
                                         :src="item.url"
                                         @click="onFileClick(item)"/>
                                </div>
                            </div>
                            <div class="audio_wrapper" id='audio'>
                                <div class="audio_delete" id="audio_delete" v-if="recordedAudio.length > 0"
                                     @click="deleteAudioClick">
                                    <img src="@/assets/icons/ic_trash.svg" alt="">
                                </div>
                                <audio controls='controls' v-if="recordedAudio.length > 0">
                                    <source :src="audioLink">
                                </audio>
                            </div>
                            <div class="feedback-wrapper"  v-if="needShowWantToHearBackBlock()">
                                <div class="feedbackCheckbox-wrapper" @click="feedbackBlock = !feedbackBlock">
                                    <input type="checkbox" v-model="feedbackBlock">
                                    <label>
                                        <div>
                                            <span class="feedback-text">{{ getWantToHearBackText() }}</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="feedback-input" v-if="feedbackBlock == true">
                                    <div class="feedback-buttons__wrapper" v-if="!this.isAuthorized">
                                        <div class="feedback-buttons">
                                            <div class="feedback-buttons__google" @click="onGoogleSingIn">
                                                <img src="@/assets/icons/ic_google_logo.svg">
                                            </div>
                                            <div class="feedback-buttons__facebook" @click="onFacebookSignIn">
                                                <img src="@/assets/icons/ic_facebook_logo.svg">
                                            </div>
                                            <v-facebook-login @sdk-init="sdkLoaded" app-id="770275700057951"
                                                              hidden></v-facebook-login>
                                        </div>
                                        <span>
                                        {{ translate('feedbackTextOr') }}
                                    </span>
                                    </div>
                                    <div class="commentTextarea">
                                        <input :placeholder="translate('commentPopupEmail')" class="feedback__input"
                                               v-model="feedbackEmailValue">
                                    </div>
                                </div>
                            </div>
                            <div v-else class="feedback-wrapper-spacer"></div>
                            <div class="socialReview-btn"
                                 v-if="anonComment == true && rate_id == 3 && (getPlaceLinks() && getPlaceLinks().length > 0)"
                                 @click="anonComment = false">
                                <div class="socialReview-btn-text">{{ translate('reviewSocialOr') }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="this.showServiceLogInfoPopup && !checkRateAndLinksCount() && anonComment == false" class="service_log_info-btn" @click="onServiceInfoClick">
                      <div class="service_log_info-btn_wrapper">
                        <img src="@/assets/icons/clipboard-text-clock.svg" alt="">
                        <div class="service_log_info-btn__text">
                          {{translate('serviceLogInfoBtn')}}
                        </div>
                      </div>
                    </div>
                </div>

                <div class="bottom-button-group">

                    <div class="socialReviewWrapper">
                        <div class="socialReview__block"
                             v-if="anonComment == false && checkRateAndLinksCount()">
                            <div v-if="this.showServiceLogInfoPopup" class="service_log_info-btn" @click="onServiceInfoClick">
                              <div class="service_log_info-btn_wrapper">
                                <img src="@/assets/icons/clipboard-text-clock.svg" alt="">
                                <div class="service_log_info-btn__text">
                                  {{translate('serviceLogInfoBtn')}}
                                </div>
                              </div>
                            </div>
                            <div class="block-title" v-if="getCurrentDefScreenConfig() && getCurrentDefScreenConfig().social_title">
                                {{ getCurrentDefScreenConfig().social_title }}
                            </div>
                            <div class="block-btn__wrapper" v-for="(link, index) in getPlaceLinks()"
                                 :key="index"
                                 @click="openSocialLink(link)">
                                <div class="block-btn">
                                    <img alt="" src="@/assets/icons/ic_facebook_color.svg" v-if="link.network.id == 1">
                                    <img alt="" src="@/assets/icons/ic_yelp.svg" v-if="link.network.id == 2">
                                    <img alt="" src="@/assets/icons/ic_google.svg" v-if="link.network.id == 3">
                                    <img alt="" src="@/assets/icons/ic_tripadvisor_color.svg"
                                         v-if="link.network.id == 4">
                                    <img alt="" src="@/assets/icons/ic_vk_color.svg" v-if="link.network.id == 6">
                                    <img alt="" src="@/assets/icons/ic_instagram_color.svg" v-if="link.network.id == 5">
                                    <img alt="" src="@/assets/icons/ic_web_color.svg" v-if="link.network.id == 7">
                                    <img alt="" src="@/assets/icons/ic_donate.svg"
                                         v-if="link.network.alias == 'donate'">
                                    <img alt="" src="@/assets/icons/ic_adopt.png" v-if="link.network.alias == 'adopt'">
                                    <img alt="" src="@/assets/icons/ic_trustpilot.svg"
                                         v-if="link.network.alias == 'trustpilot'">
                                    <img alt="" src="@/assets/icons/ic_capterra.svg"
                                         v-if="link.network.alias == 'capterra'">
                                    <div>{{ link.network.name }}</div>
                                </div>
                            </div>
                            <div v-if="this.place_info.place.uid == '88c24ea5-6f4d-444d-9663-3897011913b1'">
                                <img alt="" src="@/assets/rsa_gif.gif" style="max-width: 300px;"
                                     v-if="tallWindow">
                                <img alt="" src="@/assets/rsa_gif.gif" style="max-width: 200px;" v-else>
                            </div>

                        </div>

                    </div>
                    <div class="main_giveaway giveaway" @click="onOpenGiveawayClick"
                         v-if="giveaway.enabled && ((anonComment == false && checkRateAndLinksCount()) || giveaway.giveaway_title == 'm&k')">
                        <div class="block-btn giveaway" :class="{active: giveaway.participates, m_and_k: giveaway.giveaway_title == 'm&k'}">
                            <div class="giveaway-text__wrapper" v-if="!giveaway.participates">
                                <div v-if="giveaway.giveaway_title == 'jbar'">
                                    <div class="giveaway-text">{{ translate('ambassadorBtn_title') }}</div>
                                    <div class="giveaway-text">{{ translate('ambassadorBtn_subtitle') }}</div>
                                </div>
                                <div v-if="giveaway.giveaway_title == 'm&k'">
                                    <div class="giveaway-text">JOIN M&K GIVEAWAY CONTEST</div>
                                </div>
                                <div v-if="giveaway.giveaway_title == 'wasted'">
                                    <div class="giveaway-text">JOIN WASTED* GIVEAWAY CONTEST</div>
                                </div>
                            </div>
                            <div class="giveaway-text__wrapper" v-else>
                                <div v-if="giveaway.giveaway_title == 'jbar'">
                                    <div class="giveaway-text">{{ translate('welcomeAmbassador') }}</div>
                                </div>
                                <div v-if="giveaway.giveaway_title == 'm&k'">
                                    <div class="giveaway-text">YOUR M&K GIVEAWAY</div>
                                    <div class="giveaway-text">CONTEST RULES</div>
                                </div>
                                <div v-if="giveaway.giveaway_title == 'wasted'">
                                    <div class="giveaway-text">YOUR WASTED* GIVEAWAY</div>
                                    <div class="giveaway-text">CONTEST RULES</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <a href="https://air-vote.com/" target="_blank" class="footer-link">{{
                            translate('powered_by')
                        }}</a>
                    <div v-if="testTemplateBlocksEnabled"
                         style="height: 44px; background-color: #6D6D6D; width: 100%;"></div>
                </div>
            </div>
        </div>
            <div class="popupModal" :class="{active: selectedFile != null}">
                <div class="popupModal__wrapper" @mousedown='underlayClick'>
                    <div class="popupModal__content" id="popupModal__content">
                        <div class="close-icon__wrapper">
                            <span class="close-icon" @click="selectedFile = null">
                                <img src="@/assets/icons/ic_close_white.svg">
                            </span>
                        </div>
                        <div class="photo-modal__wrapper">
                            <div class="photo-modal__image">
                                <img v-if="selectedFile" :src="selectedFile.url"/>
                            </div>
                        </div>
                        <div class="photo-modal__buttons">
                            <div class="photo-modal__delete" @click="onDeleteImageClick">
                                {{ translate('RemovePhoto') }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        <div style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; background: white;" v-if="this.hideInitialOnLoading"></div>
<!--        <Dino :settings="dinoSettings"></Dino>-->
        <!--        <DinoButton :settings="{onClickHandler: this.dinoBtnClick}"  v-if="+this.rate_id == 3 || !this.place_info.place.show_sec_level"/>-->
    </div>

</template>

<script>

import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import {isValidUrl} from '@/helpers/customValidators'
import rateMixin from '@/mixins/rateMixin';
import errorMixin from '@/mixins/errorMixin';
import geoLocationMixin from "@/mixins/geoLocationMixin";
import navMixin from '@/mixins/navMixin';
import logAnalyticsEvent from '@/helpers/analytics'
import config from '@/api/config';
import giveawayModal from "./widgets/giveawayModal";
import profileIcon from "./voteFlow/widgets/profileIcon.vue";
import socialReviewBtnFlow from "./voteFlow/widgets/socialReviewBtnFlow.vue";
import explainGeolactionPopup from "./widgets/explainGeolactionPopup";
import geolocationLoadingPopup from "./widgets/geolocationLoadingPopup";
import Dino from "@/components/widgets/Dino";
import DinoButton from "@/components/widgets/DinoButton";
import recordAudioBtn from "@/components/widgets/recordAudioBtn"
import publicReviewPopup from "./widgets/publicReviewPopup";
import googleAutoReviewPopup from "./widgets/googleAutoReviewPopup";
import staffLoginModal from "./widgets/staffLogInModal";
import serviceLogInformPopup from "@/components/widgets/serviceLogInformPopup";
import snapPicturePopup from "./widgets/snapPicturePopup";
import InlineSvg from 'vue-inline-svg';

export default {
        name: 'AirVote',
    components: {
        serviceLogInformPopup,
        giveawayModal,
        profileIcon,
        socialReviewBtnFlow,
        explainGeolactionPopup,
        geolocationLoadingPopup,
        Dino,
        DinoButton,
        recordAudioBtn,
        publicReviewPopup,
        googleAutoReviewPopup,
        staffLoginModal,
        snapPicturePopup,
        InlineSvg,
    },
        comments: {
            giveawayModal,
        },
        mixins: [mixin, errorMixin, rateMixin, navMixin, geoLocationMixin],
        data() {
            return {
                testTemplateBlocksEnabled: false,
                commentText: '',
                loadingAction: false,
                commentModal: false,
                anonComment: false,
                socialModal: false,
                signInLoading: false,
                feedbackBlock: false,
                feedbackEmail: null,
                place_img: '',
                place_info: {
                    place: {
                        name: '',
                    },
                    question: ''
                },
                currentVote: null,
                voteBoll: true,
                question_id: this.$route.params.id,
                rate_id: this.$route.params.number,
                successRegistration: false,
                sendRateClass: false,
                rateMessage: '',
                personalID: 0,
                email: '',
                name: '',
                thanksReplaceRoute: '/thank-for-vote/',
                giveawayModalSettings: null,
                staffLogInModalSettings: {
                    show: false,
                    hideOnClickOutside: true,
                },
                showSocialReviewPopup: false,
                phoneWindowSizeSE: null,
                tallWindow: false,
                files: [],
                photoSize: 20, // megabytes
                maxFiles: 5,
                selectedFile: null,
                rectangles: [],
                showCommentBlock: false,
                explainGeolocationPopupSettings: null,
                geolocationLoadingPopupSettings: null,
                snapPicturePopupSettings: null,
                recorder: null,
                deleteRecordAudioImage: null,
                recordedAudio: [],
                audioLink: null,
                recordInProgress: false,
                sendAllWhenRecordReady: false,
                askedLocation: false,
                dinoSettings: null,
                recordAudioBtnSettings: {
                    recordInProgressBool: this.recordInProgress,
                    startRecord: this.recordAudio,
                    stopRecord: this.stopRecordAudioClick,
                    primaryColor: '#424242',
                },
                place_guid: null,
                hideInitialOnLoading: false,
                counter: 0,
                publicReviewPopupSettings: null,
                googleAutoReviewPopupSettings: null,
                publicReviewPopupShown: false,
                googleAutoReviewPopupShown: false,
                profileIconSettings: {
                    question_uid: null,
                    serviceLog: {
                      available: false,
                      requirePin: false,
                    },
                    newServiceLog: {
                      available: false,
                    },
                    qc: {
                      available: false,
                    },
                    isServiceLog: false,
                    showPinLoginOption: false,
                    showTrackInventoryOption: false,
                },
                serviceLogMode: false,
                newPlacement: '',
                serviceInfoModalSettings: null,
                serviceLogRates: [],
                showServiceLogInfoPopup: false,
                placesUidForSnapPicturePopup: new Set(['4e591be8-043a-4ff3-b75d-8388f1974aaa', '206eb5a5-463b-42e9-a925-dae08a591b52']), //IND, J Bar Portables
                showBottomSnapPictureBlock: false,
                sldIndexForImage: null,
                maxCommentLength: 200,
                showYellowSmiley: true,
            }
        },
        watch: {
            isAuthorized(newValue) {
                if (!newValue) {
                    this.$store.commit('rate/clearGiveaway')
                }
            },
            'rate_id'(newValue) {
                this.$store.commit('rate/setRateValue', newValue)
            },
            feedbackBlock(newValue) {
                if(newValue) {
                    this.sendLog('want_hear_back_checked')
                }
            },
        },
        props: {
            msg: String
        },
        computed: {
            ...mapState({
                accessToken: state => state.auth.accessToken,
                anonymousToken: state => state.auth.anonymousToken,
                voted: state => state.voted,
            }),

        ...mapGetters({
            isUserOwner: 'auth/isUserOwner',
            isUserAdmin: 'auth/isUserAdmin',
            isUserClient: 'auth/isUserClient',
            hasOwnPlace: 'auth/hasOwnPlace',
            isAuthorized: 'auth/isAuthorized',
            giveaway: 'rate/getGiveaway',
            userInfo: 'auth/getUserInfo',
            questionManageData: 'auth/getQuestionManageData',
            getRateUid: 'rate/getRateUid',
            getRateValue: 'rate/getRateValue',
            getQuestionUid: 'rate/getQuestionUid',
            getAnonymousTokenDataFromState: 'auth/getAnonymousTokenDataFromState',
        }),
        hasQuestionAccess() {
            return this.questionManageData != null && this.questionManageData.uid == this.getQuestionUid && this.questionManageData.access
        },
        questionManageDataServiceLogEnabled() {
            return this.questionManageData != null && this.questionManageData.uid == this.getQuestionUid && this.questionManageData.service_log_enabled
        },
        questionManageNewSLEnabled() {
            return this.questionManageData != null && this.questionManageData.uid == this.getQuestionUid && this.questionManageData.new_service_log_enabled
        },
        hasAirLead() {
            return this.questionManageData != null && this.questionManageData.airlead_enabled
        },
        feedbackEmailValue: {
            get() {
                return this.feedbackEmail == null ? this.userInfo.contact_email : this.feedbackEmail
            },
            set(value) {
                this.feedbackEmail = value
            }
        },
        smallCommentTextAreaPaddingBottom() {
            return this.commentText.split('\n').length > 1 ? '12px' : '0'
        },
    },
    async mounted() {
            this.question_id = this.$route.params.id;
            if(this.question_id == '1b2d23e9-8c9a-4ba7-a036-6e56044cd115') { //redirect for Bob's Septic Giveaway
                window.location.replace(`${location.origin}/r/${this.question_id}/bslead/3`)
                return
            }
        if(this.$route.query.sl == 't' || this.isServiceLogRoute()) {
                this.applyInitialOnLoading(true)
            }this.phoneWindowSizeSE = window.matchMedia('(max-width: 321px)').matches
        this.tallWindow = !window.matchMedia('(max-height: 740px)').matches
        this.profileIconSettings.question_uid = this.question_id;
        this.rate_id = this.$route.params.number;
        this.$store.commit('rate/setRateValue', this.$route.params.number)
        this.$store.commit('rate/setQuestionUid', this.question_id)
        this.$store.commit('auth/setQuestionUid', this.question_id)
        if (this.isAuthorized) {
            await this.fetchUserInfo()
            if (this.hasAirLead) {
                let leadType = this.rate_id == 3 ? 'existing' : 'new'
                window.location.replace(`${location.origin}/questions/${this.getQuestionUid}/airlead/${leadType}`)
                return
            }
            let forceVote = this.$route.query.force_vote == 'true' ? true : false
            if (this.questionManageNewSLEnabled && !forceVote
                && this.userInfo.email != 'ovg0000+biffscustomer@gmail.com' //not Biffs Customer (should get QC)
            ) {
                this.navToNewSL(this.question_id)
                return
            }
            if (this.questionManageDataServiceLogEnabled && !this.isServiceLogRoute() && !forceVote) {
                this.navToServiceLog(this.question_id)
                return
            }
            if (this.hasQuestionAccess && this.$route.query.from_manage != 'true' && !this.isServiceLogRoute() && !forceVote
                && this.question_id != "7a97ad01-cf3a-4076-9216-aa522fd2e434"  //not AirCompare question
                && this.userInfo.email != 'colin@thronedepot.com' //not Colin from Throne Depot
            ) {
                window.location.replace(`${location.origin}/questions/${this.getQuestionUid}/manage`)
                return
            }
            this.feedbackEmail = this.userInfo.contact_email
        }
        if (performance.navigation.type !== 1 || (this.isServiceLogRoute() && this.currentVote == null)) {
            const rateData = await this.sendRateAndGetInfo(this.question_id, this.rate_id)
            this.currentVote = rateData
            this.applyInitialOnLoading(false)
            this.saveLog(`vote_screen after sendRateAndGetInfo question_id:${this.question_id} | rate_id:${this.rate_id} | access_token:${localStorage.getItem('access_token')} | anon_token: ${localStorage.getItem('anonymous_token')} or ${this.getAnonymousTokenDataFromState.token}`)
            this.applyServiceLogMode()
            this.getSecondLevelDetailsItemsAction() //todo add await ?
            this.showCommentPopupIfNeed()
            console.log(this.place_info)
            if(
                this.place_info.place.uid == '71bec9b0-d20c-4464-ba32-e60045698ad5' //CCIA - TSA
                || this.place_info.place.uid == 'fd165e34-9dcb-4e2e-bd71-35fd79bc60c0' //CCIA - Terminal
                || this.place_info.place.uid == 'e8f08c00-7227-4f0a-b543-97af67120f2e' //CCIA
                || this.place_info.place.uid == '3dbc197f-6e0c-487d-bbbb-20ca917bd252' //CCIA - Facilities
            ) {
                this.showYellowSmiley = false
            }
            if(this.place_info.place.uid == '13a78fed-8ba6-4c35-b5f5-e0e8aaf088eb') {
                this.feedbackBlock = true
            }
            if(this.place_info.place.uid == '4d9d64a3-0d1a-4631-ba74-f4cf6b318332') {
                this.maxCommentLength = 60
            }
            if(this.place_info.place.uid == '7e89ed08-2d70-4584-b20f-5836df2a4c28') { //Throne Depot
                this.profileIconSettings.showTrackInventoryOption = true
            }
            if(this.place_info.place.uid == 'e1b0633b-54f1-44f3-9bf2-7dcbe56a6d97') { //Sonlight Services LLC
                this.profileIconSettings.newServiceLog.available = true
            }
            if(this.place_info.place.uid == 'a3b249e0-078a-4796-9670-c607387295aa') { //St. Mark's Hospital (HCA)
                this.profileIconSettings.newServiceLog.available = true
            }
            if(
               this.place_info.place.uid == '18b64cb0-2482-46c3-85ac-2c9ba295cc62'
                || this.place_info.place.uid == '8583e852-ef65-4f27-8dca-e5bbbe560b16'
            ) { //Biffs new setup (without 79b05d06-6257-4b3c-b3aa-1246e6f2713b)
                this.profileIconSettings.newServiceLog.available = true
                this.profileIconSettings.qc.available = true
            }
            this.$store.commit('rate/setRateUid', rateData.uid)
            this.setVotedState(true)
            this.updateUrl()
            this.redirectToSocial(this.place_info.place.uid)
            this.newPlacement = this.place_info.placement
            if (this.shouldAskLocationImmediately()) {
                this.askedLocation = true
                let hasLocationPermission = await this.hasLocationPermission()
                if (!hasLocationPermission) {
                    this.showExplainGeolocationPopup(() => {this.initFetchLocationFlow(this.onGpsFetchSuccess, this.onGpsFetchError)})
                } else {
                    this.initFetchLocationFlow(this.onGpsFetchSuccess, this.onGpsFetchError)
                    this.showAdditionalPopupsIfNeeded()
                }
            } else {
                this.showAdditionalPopupsIfNeeded()
            }
            this.profileIconSettings.showPinLoginOption = true
                // this.place_info.place.uid == 'ef36e4db-eea9-4d89-b71e-4382f44c88ee' //DenverSiteWorks Dumpsters Fencing Restrooms
                // || this.place_info.place.uid == 'f89cd8c3-c24a-408c-8a8d-53861f04d07e' //R&R Sanitation
                // || this.place_info.place.uid == '206eb5a5-463b-42e9-a925-dae08a591b52' //J Bar – Portables
                // || this.place_info.place.uid == '4561011d-d602-4553-a04f-498e9c25c0e4' //J Bar - Dumpsters
                // || this.place_info.place.uid == '1c7790f2-7089-430e-a502-d2b6f57488e3' //2 Pees in a Pot
                // || this.place_info.place.uid == 'fd86eb99-cc9d-4aad-ab27-86fef9ecb7fb' //Mr John
        } else {
            this.$router.push({
              name: 'ThanksCreateNote',
              params: {questionId: this.question_id, number: this.rate_id, rateUid: this.currentVote.uid}
            })
        }
    },
    methods: {
        ...mapActions({
            sendSocialClick: 'rate/sendSocialClick',
            changeRate: 'rate/changeRate',
            fetchUserInfo: 'auth/fetchUserInfo',
            sendLocationError: 'auth/sendLocationError',
            sendVoteGeolocation: 'rate/sendVoteGeolocation',
            createComment: 'comment/createComment',
            attachPhotoAction: 'comment/attachPhoto',
            detachPhotoAction: 'comment/detachPhoto',
            saveLog: 'auth/saveLog',
            sendRateLog: 'auth/sendRateLog',
            handleAnswer: 'rate/handleAnswer',
            changeQuestionPlacement: 'rate/changeQuestionPlacement',
            getServiceLogInfo: 'rate/getServiceLogInfo'
        }),

        ...mapMutations({
            setVotedState: 'setVotedState',
            removeKeys: 'auth/removeKeys',
            setProgressBarTag: 'setProgressBarTag'
        }),
        async onGoogleSingIn() {
            await this.GoogleSignIn({
                becomeOwner: false,
                redirect: false
            })
            logAnalyticsEvent(`signin_logingg`)
            if (this.isAuthorized) {
                await this.onGotUserCreds()
            }
        },
        async onFacebookSignIn() {
            logAnalyticsEvent(`signin_loginfb`)
            await this.FacebookSignIn({
                becomeOwner: false,
                redirect: false
            })

            if (this.isAuthorized) {
                await this.onGotUserCreds()
            }
        },
        async onGotUserCreds() {
            await this.fetchUserInfo()
            if (this.hasQuestionAccess
                && this.question_id != "7a97ad01-cf3a-4076-9216-aa522fd2e434" //not AirCompare question
            ) {
                let url = `${location.origin}/questions/${this.question_id}/manage?rate_uid=${this.currentVote.uid}&rate_value=${this.rate_id}&is_sl=${this.serviceLogMode}`
                window.location.replace(url)
            }
        },
        openSocialLink(link) {
            logAnalyticsEvent('vote_screen_soc_review_item_click')
            this.sendSocialClickToServer(this.currentVote.uid, link.uid)
            window.open(link.url, '_blank');
        },
        openSocialLinkAuto(link) {
            logAnalyticsEvent('vote_screen_soc_review_item_timer_open')
            this.sendSocialClickToServer(this.currentVote.uid, link.uid)
            let result = window.open(link.url, '_blank');
            return result != null && typeof(result) != 'undefined'
        },
        redirectToSocial(placeUid) {
            if(this.currentVote && this.currentVote.social_redirect && this.currentVote.social_redirect.url) {
                window.location.replace(this.currentVote.social_redirect.url)
            }
        },
        onPlaceNameClick() {
            logAnalyticsEvent('vote_screen_place_title_click')
            this.openSiteUrl()
        },

        onPlaceImageClick() {
            logAnalyticsEvent('vote_screen_place_img_click')
            this.openSiteUrl()
        },
        onFileSelected(event) {
            console.log(`onFileSelected files:`, event.target.files)
            for (let i = 0; event.target.files.length > i; i++) {
                let selectedFile = event.target.files[i];
                if (selectedFile.type != 'image/png' && selectedFile.type != 'image/jpeg') {
                    this.showErrorModal(this.translate('WrongFormat'))
                } else if ((selectedFile.size >= (this.photoSize * 1048576))) {
                    this.showErrorModal(this.translate('PhotoOverweight', [this.photoSize]))
                } else {
                    if (this.files.length == this.maxFiles) {
                        this.$refs.fileInput.value = ''
                        // this.$refs.fileInputOnlyPhoto.value = ''
                        this.showErrorModal(this.translate('max_attach_photos_count_error', [this.maxFiles]))
                        return
                    }
                    let sldIndex = this.sldIndexForImage
                    this.sldIndexForImage = null
                    if(sldIndex != null) {
                        this.sendLog('picture_chosen', {sld: this.rectangles[sldIndex].text }) //todo add SLD name if chosen???
                    }
                    let file = {
                        file: selectedFile,
                        url: URL.createObjectURL(selectedFile),
                        isUploading: false,
                        uploadedFile: null,
                    }
                    if(sldIndex != null) {
                        console.log(`created file for sld ${sldIndex} :`, file)
                        this.rectangles[sldIndex].file = file
                        this.attachPhoto(file, this.rectangles[sldIndex].text)
                    } else {
                        console.log(`added comments file`, file)
                        this.files.push(file)
                    }
                }
            }
            console.log(`files`, this.files)
            this.$refs.fileInput.value = ''
            // this.$refs.fileInputOnlyPhoto.value = ''
        },

        openSiteUrl() {
            let url = this.place_info.place.site_url
            if (isValidUrl(url)) {
                window.open(url, '_blank')
            }
        },

        onQuestionNameClick() {
            logAnalyticsEvent('vote_screen_question_title_click')
        },

        canSendComment() {
            return !(this.commentText.length == 0 && (this.feedbackEmail == null || this.feedbackEmail.length == 0) && this.files.length == 0 && this.recordedAudio.length == 0 && !this.recordInProgress)
        },
        async onSaveComment() {
            if (!this.canSendComment()) {
                this.sendLog('send_attachment_click', {canceled: 'fields empty'})
                logAnalyticsEvent('vote_screen_comment_dlg_send_empty_clck')
                return
            }
            console.log('onSaveComment');
            if (this.recordInProgress) {
                this.sendAllWhenRecordReady = true
                this.sendLog('send_attachment_click', {delayed: 'record in progress - stopping'})
                this.stopRecordAudio()
                return
            }
            logAnalyticsEvent('vote_screen_comment_dialog_send_click')
            try {
                this.loadingAction = true
                let askLocation = this.shouldAskLocation()
                this.setProgressBarTag({
                    show: true,
                    tag: 'comment'
                })
                this.saveLog(`send createComment voteId:${this.currentVote.uid} commentText:${this.commentText} access_token:${localStorage.getItem('access_token')} | anon_token: ${localStorage.getItem('anonymous_token')} or ${this.getAnonymousTokenDataFromState.token}`)
                this.sendLog('send_attachment_click', {will_ask_gps: askLocation})
                //feedbackBlock
                let contactInfo = this.feedbackEmail == null ? '' : this.feedbackEmail
                if(this.feedbackBlock && contactInfo == '' && this.place_info.place.uid == 'e4e56956-c106-43fc-becc-b71e2bb94a89') { //M&K (Kody)
                    contactInfo = '_'
                }
                let response = await this.createComment({
                    voteId: this.currentVote.uid,
                    commentText: this.commentText,
                    feedbackEmail: contactInfo,
                    feedbackPhotos: this.files.map(item => item.file),
                    feedbackAudio: this.recordedAudio.length > 0 ? new Blob(this.recordedAudio, {type: this.recorder.mimeType,}) : null
                })
                this.commentText = ''
                this.commentModal = false
                logAnalyticsEvent('vote_screen_comment_dialog_sent_success')
                if (response.data.uploadErrors) {
                    logAnalyticsEvent('vote_screen_comment_photo_error')
                    this.showErrorModal("Some attachments where not sent.\nPlease try again")
                }
                if (askLocation) {
                    let hasLocationPermission = await this.hasLocationPermission()
                    if (!hasLocationPermission) {
                        this.showExplainGeolocationPopup(this.redirectAndAskGeolocationAction, this.redirectAndSaveCommentAction)
                    } else {
                        this.redirectAndAskGeolocationAction()
                    }
                } else {
                    this.goToThankForVote()
                }

            } catch (error) {
                this.saveLog(`error createComment voteId:${this.currentVote.uid} commentText:${this.commentText} error:${error.message ? error.message : JSON.stringify(error)} \n ${error.stack ? error.stack : ''}`)
                console.log('error', error)
                logAnalyticsEvent('vote_screen_comment_dialog_sent_error', {
                    msg: error.data.error.message
                })
                this.showErrorModal(error.data.error.message)
            } finally {
                this.loadingAction = false
                this.setProgressBarTag({
                    show: false,
                    tag: 'comment'
                })
            }
        },
        async attachPhoto(file, sldText) {
            try {
                file.isUploading = true
                let response = await this.attachPhotoAction({
                    voteId: this.currentVote.uid,
                    photo: file.file,
                    sldText: sldText,
                })
                let image = response.data.image
                file.uploadedFile = image
            } catch (error) {
                console.log('error', error)
                this.showErrorModal(error.data.error.message)
                this.files.splice(this.files.indexOf(file))
            } finally {
                file.isUploading = false
            }
        },
        async detachPhoto(fileUid) {
            try {
                let response = await this.detachPhotoAction({
                    voteId: this.currentVote.uid,
                    photoUid: fileUid,
                })
            } catch (error) {
                console.log('error', error)
            } finally {
            }
        },
        redirectAndAskGeolocationAction() {
            this.goToThankForVote()
            this.initFetchLocationFlow(this.onGpsFetchSuccess, this.onGpsFetchError)
        },
        redirectAndSaveCommentAction() {
            this.goToThankForVote()
        },
        onAirVoteLogoClick() {
            window.open(`${config.siteUrl}/${this.$ml.current}`, '_blank').focus()
        },

        goToThankForVote() {
            if(this.serviceLogMode) {
                this.$router.push({
                    name: 'ServiceLogFinal',
                    params: {questionId: this.question_id, rateUid: this.currentVote.uid}
                })
            } else {
                this.$router.push({
                    name: 'ThanksCreateNote',
                    params: {questionId: this.question_id, number: this.rate_id, rateUid: this.currentVote.uid}
                })
            }
        },

        showCommentPopupIfNeed() {
            try {
                if (+this.rate_id !== 3) {
                    this.commentModal = true
                }
            } catch (e) {
                logAnalyticsEvent('showCommentPopupIfNeed_Error')
            }
            try {
                this.showSocialReviewPopup = (+this.rate_id === 3) && this.hasDonateLinks()
            } catch (e) {
                logAnalyticsEvent('showSocialReviewPopup_Error')
            }
        },

        getPlaceLinks() {
            return this.place_info.place.links.filter(item => item.enabled)
        },

        hasDonateLinks() {
            return this.getPlaceLinks().find(item => item.network.alias == 'donate' || item.network.alias == 'adopt') != null
        },

        async changeRateRote(id) {
            if (this.rate_id != id) {

                logAnalyticsEvent('vote_screen_change_vote', {
                    value: id
                })

                try {
                    this.signInLoading = true
                    this.saveLog(`send changeRate voteId:${this.currentVote.uid} access_token:${localStorage.getItem('access_token')} | anon_token: ${localStorage.getItem('anonymous_token')}`)
                    await this.changeRate({
                        changeRateID: this.currentVote.uid,
                        rate: id
                    })
                } catch (error) {
                    this.saveLog(`error changeRate voteId:${this.currentVote.uid} commentText:${this.commentText} error:${error.message ? error.message : JSON.stringify(error)} \n ${error.stack ? error.stack : ''}`)
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.rate_id = id;
                    this.signInLoading = false
                    this.showCommentPopupIfNeed()
                    this.updateUrl()
                    this.getSecondLevelDetailsItemsAction()
                    this.showAdditionalPopupsIfNeeded()
                    this.redirectToSocial(this.place_info.place.uid)
                }
            }
            if (this.place_info.place.uid == 'e4e56956-c106-43fc-becc-b71e2bb94a89' && id == 3) window.open('https://search.google.com/local/writereview?placeid=ChIJ_3xiCoEvxFIRSsy2AQC8-CU', '_blank')
            // if (this.place_info.place.uid == 'eaa4b16f-30c2-45ac-b04d-4b83107cc96c' && id == 3) window.open('https://search.google.com/local/writereview?placeid=ChIJ1-QkTDtwcEgRbnGSKpsZrbY', '_blank')
        },

        updateUrl() {
            if(this.serviceLogMode) {
                this.replaceUrlWithServiceLogFinal()
            } else {
                history.replaceState(
                    {},
                    null,
                    location.origin + '/r' + this.thanksReplaceRoute + this.question_id + '/' + this.rate_id + '/' + this.currentVote.uid + `?ouid=${this.place_info.org_uid}&r=${this.rate_id}`
                )
            }
        },

        replaceUrlWithServiceLogFinal() {
            history.replaceState(
                {},
                null,
                location.origin + '/r/slf/' + this.question_id + '/' + (this.currentVote == null ? '' : this.currentVote.uid)
            )
        },
        replaceUrlWithServiceLogDirect() {
            history.replaceState(
                {},
                null,
                location.origin + '/r/sl/' + this.question_id
            )
        },
        openCommentModal() {
            logAnalyticsEvent('vote_screen_comment_btn_click')
            this.commentModal = true
        },
        cancelCommentModal() {
            logAnalyticsEvent('vote_screen_comment_dialog_cancel')
            this.commentModal = false
            this.commentText = ''
        },

        onOpenGiveawayClick() {
            logAnalyticsEvent('vote_screen_giveaway_click')
            this.showGiveawayPopup()
        },
        showGiveawayPopup() {
            this.giveawayModalSettings = {
                showCancelButton: false,
                hideOkButton: true,
                place_info: this.place_info,
                currentVoteUid: this.currentVote.uid,
                question_id: this.question_id,
                onPhoneSentHandler: () => {
                    console.log(`onPhoneSentHandler`)
                    this.giveawayModalSettings = null
                    this.$store.commit('rate/setGiveawayParticipates', true)
                    this.afterNewGiveawayFlow()
                },
                onCancelHandler: () => {
                    if(this.place_info.place.uid == 'e4e56956-c106-43fc-becc-b71e2bb94a89' //M&K
                    || this.place_info.place.uid == '9d6cd38f-a7cd-44ee-8c13-c88c9ef73302' //Wasted* PBC - Burlington
                    || this.place_info.place.uid == '3f6425dd-f7f0-45c5-9513-0f5b2684fb7a' //Wasted* PBC - Boston
                    ) {
                        this.afterNewGiveawayFlow()
                    }
                },
            }
        },
        afterNewGiveawayFlow() {
            console.log(`afterNewGiveawayFlow`)
            if(this.rate_id == 3) {
                this.showAutoGoogleRedirectPrompt(()=> {
                    console.log(`showAutoGoogleRedirectPrompt actionDoneCallback`)
                    this.startGeolocationAfterGiveawayFlow()
                })
            } else {
                this.startGeolocationAfterGiveawayFlow()
            }
        },
        async startGeolocationAfterGiveawayFlow() {
            console.log(`startGeolocationAfterGiveawayFlow`)
            if(this.place_info != null && (this.place_info.ask_vote_gps || this.place_info.special_ask_vote_gps) && !this.askedLocation) {
                console.log(`startGeolocationAfterGiveawayFlow inner`)
                this.askedLocation = true
                let hasLocationPermission = await this.hasLocationPermission()
                if (!hasLocationPermission) {
                    this.showExplainGeolocationPopup(() => {this.initFetchLocationFlow(this.onGpsFetchSuccess, this.onGpsFetchError)}, null, false)
                } else {
                    this.initFetchLocationFlow(this.onGpsFetchSuccess, this.onGpsFetchError)
                }
            }
        },
        underlayClick(e) {
            if (this.isClickOutOfBlock('popupModal__content', e.target)) {
                console.log(`underlayClick`)
                this.selectedFile = null
            }
        },

        onCommentFieldFocus() {
            document.getElementById('comment_wrapper_big').style.visibility = 'visible'
            document.getElementById('comment__textarea_big').focus()
        },

        onCommentBigFieldFocusOut() {
            document.getElementById('comment__textarea').scrollTo(0, 1000)
            document.getElementById('comment_wrapper_big').style.visibility = 'hidden'
        },

        autoGrowTextArea(event) {
            let element = event.target
            element.style.height = "5px";
            let height = element.scrollHeight - 4
            if (height <= element.style.minHeight) height = element.style.minHeight
            element.style.height = (height) + "px";
        },

        onAttachClick() {
            this.sendLog('attach_photo_btn_click')
            this.attach()
        },
        onAttachBottomBlockClick() {
            this.sendLog('attach_bottom_block_click')
            this.attach()
        },
        attach(sldIndexForImage = null) {
            this.sldIndexForImage = sldIndexForImage
            this.$refs.fileInput.multiple = (sldIndexForImage == null) && this.serviceLogMode
            if (this.files.length < this.maxFiles || sldIndexForImage) {
                this.$refs.fileInput.click()
            }
        },
        attachOnlyPhoto() {
            if (this.files.length < this.maxFiles) {
                this.$refs.fileInputOnlyPhoto.click()
            }
        },
        hasCommentImages() {
            return this.files.length > 0
        },
        onFileClick(item) {
            console.log(`onFileClick`)
            this.selectedFile = item
        },
        getCurrentBlocksConfig() {
            if(this.serviceLogMode) {
                return this.getServiceLogConfig()
            } else {
                return this.getCurrentSecondLevelDetails()
            }
        },
        getBlocksScreenBackground() {
            return this.getCurrentBlocksConfig().background
        },
        getRectLblColor(index) {
            if(this.rectangles[index].active) {
                return '#ffffff'
            } else {
                return this.getCurrentBlocksConfig().primary_color
            }
        },
        getBlocksScreenPrimaryColor() {
            return this.getCurrentBlocksConfig().primary_color
        },
        getBlocksScreenTitle() {
            return this.getCurrentBlocksConfig().title
        },
        getSldSubtitle() {
            if(this.getCurrentBlocksConfig() &&
                (this.getCurrentBlocksConfig().subtitle || this.getCurrentBlocksConfig().subtitle == '')) {
                return this.getCurrentBlocksConfig().subtitle
            } else {
                return this.serviceLogMode ? '' : this.translate('subtitleDefault')
            }
        },
        onDeleteImageClick() {
            if (this.selectedFile == null) return
            this.files = this.files.filter(item => {
                return item.url != this.selectedFile.url
            })
            this.selectedFile = null
            this.sendLog('picture_removed')
        },

        shouldAskLocationImmediately() {
            return this.place_info != null && (this.place_info.ask_vote_gps || this.place_info.special_ask_vote_gps) && !this.askedLocation
                && this.place_info.place.uid != 'e4e56956-c106-43fc-becc-b71e2bb94a89' //M&K (Kody)
                && this.place_info.place.uid != '50a512f9-e8a2-43d7-97b4-7c012221e40f' //Acme (local place)
        },

        shouldAskLocation() {
            return (this.place_info.placement == '' && +this.rate_id !== 3 && (this.files.length > 0 || this.commentText != '') && (this.place_info.asset_id == null || this.place_info.asset_id == ''))
                && !this.askedLocation
        },
        showShowSldUserImage(index) {
            return this.rectangles[index].active && this.getSldUserImage(index)
        },
        getRectBackground(index) {
            if(this.rectangles[index].active && this.getSldUserImage(index)) {
                return `url('${this.getSldUserImage(index) }')`
            } else if(this.rectangles[index].active) {
                return this.getBlocksScreenPrimaryColor()
            } else {
                return ''
            }
        },
        getSldUserImage(index) {
            let file = this.rectangles[index].file
            if(file) {
                return file.url
            } else {
                return null
            }
        },
        isSldUserFileUploading(index) {
            return this.rectangles[index].file && this.rectangles[index].file.isUploading
        },
        getSldUserFile(index) {
            return this.rectangles[index].file
        },
        onRectCloseClick(item, index) {
            if(item.active) {
                console.log(`onRectCloseClick for sld ${index} :`, item)
                logAnalyticsEvent(`vs_block_uncheck_clk`)
                item.active = false
                this.handleAnswerAction(item)
                this.detachPhoto(item.file.uploadedFile.uid)
                item.file = null
            }
        },
        onRectClick(item, index) {
            console.log(`onRectClick: ${index}`)
            if(item.active) {
                let userFile = this.getSldUserFile(index)
                if(userFile) {
                    if(userFile.isUploading){
                        this.sendLog('active_block_with_loading_photo_click')
                    } else {
                        this.sendLog('active_block_with_photo_click')
                        // this.selectedFile = userFile
                    }
                } else {
                    this.sendLog('active_block_click', {sld: this.rectangles[index].text })
                    this.attach(index)
                }
            } else {
                item.active = !item.active
                let maxSelectedCount = this.getCurrentBlocksConfig().selected_count_max
                let selectedCount = this.rectangles.filter((obj) => obj.active).length
                if (maxSelectedCount != 0 && selectedCount > maxSelectedCount) {
                    item.active = false
                    this.showErrorModal(this.translate('level2_maxCount', [maxSelectedCount]))
                } else {
                    if(this.shouldAutoOpenCamera(item)) {
                        this.sldIndexForImage = index
                        this.$refs.fileInputOnlyPhoto.click()
                    }
                }
                console.log(item.active)
                logAnalyticsEvent(`vs_block_check_clk`)
                this.handleAnswerAction(item)
            }
        },
        shouldAutoOpenCamera(item) {
            if(item.auto_open_camera == null) {
                if(this.getCurrentBlocksConfig().auto_open_camera != null) {
                    return this.getCurrentBlocksConfig().auto_open_camera
                } else {
                    return !this.serviceLogMode
                }
            } else {
                return item.auto_open_camera
            }
        },
        showPictureSuggestionBlockIfNeeded() {
            let selectedCount = this.rectangles.filter((obj) => obj.active).length
            this.showBottomSnapPictureBlock = this.placesUidForSnapPicturePopup.has(this.place_info.place.uid) && selectedCount > 0
        },
        async handleAnswerAction(item) {
            let data = {
                vote_uid: this.currentVote.uid,
                option: this.getTranslations(item.value),
                isDelete: !item.active,
            }
            try {
                let response = await this.handleAnswer(data)
                if (response.success) console.log(response)
                if (item.active) {
                    logAnalyticsEvent(`vs_block_check_success`)
                } else {
                    logAnalyticsEvent(`vs_block_uncheck_success`)
                }
            } catch (error) {
                this.showErrorModal(error.data.error.message)
                if (item.active) {
                    logAnalyticsEvent(`vs_block_check_send_error`)
                } else {
                    logAnalyticsEvent(`vs_block_uncheck_send_error`)
                }
            }
        },
        applyServiceLogMode() {
            let slConfig = this.getServiceLogConfig()
            this.serviceLogMode = slConfig != null && this.currentVote.is_service_log
            this.profileIconSettings.serviceLog.available = slConfig != null && !this.serviceLogMode
            this.profileIconSettings.serviceLog.requirePin = slConfig != null && slConfig.require_pin
            this.profileIconSettings.isServiceLog = this.serviceLogMode
            this.showServiceLogInfoPopup = this.place_info.show_service_log_history
            if(this.serviceLogMode) {
                this.profileIconSettings.showToVoteMenu = !slConfig.force
                this.rectangles = this.prepareRectangles(slConfig.blocks)
                this.askedLocation = true
                this.showGpsLoadingPopup()
                this.initFetchLocationFlow(this.onGpsFetchSuccess, this.onGpsFetchError)
            }
        },
        async getSecondLevelDetailsItemsAction() {
            if(this.serviceLogMode) return
            let checkRectanglesActive = this.getCurrentSecondLevelDetails()
            if (checkRectanglesActive !== null) {
                this.rectangles = this.prepareRectangles(checkRectanglesActive.blocks)
            } else {
                this.rectangles = []
            }
        },
        prepareRectangles(items) {
            for (let i = 0; items.length > i; i++) {
                items[i].active = false
                items[i].file = null
            }
            return JSON.parse(JSON.stringify(items))
        },
        checkSecondLevelDetails() {
            return this.getCurrentSecondLevelDetails() !== null
        },
        getCurrentDefScreenConfig() {
            let config = this.place_info.second_level_details_config
            if (config == null) return null
            let specificConfig = null
            switch (+this.rate_id) {
                case 1: {
                    specificConfig = config.sad
                    break
                }
                case 2: {
                    specificConfig = config.so_so
                    break
                }
                case 3: {
                    specificConfig = config.happy
                    break
                }
            }
            if (specificConfig == null || !specificConfig.default_view) return null
            return specificConfig
        },
        getCurrentSecondLevelDetails() {
            let config = this.place_info.second_level_details_config
            if (config == null) return null
            let specificConfig = null
            switch (+this.rate_id) {
                case 1: {
                    specificConfig = config.sad
                    if (specificConfig && specificConfig.primary_color == null) specificConfig.primary_color = '#ab4545'
                    break
                }
                case 2: {
                    specificConfig = config.so_so
                    if (specificConfig && specificConfig.primary_color == null) specificConfig.primary_color = '#ba7200'
                    break
                }
                case 3: {
                    specificConfig = config.happy
                    if (specificConfig && specificConfig.primary_color == null) specificConfig.primary_color = '#339C4A'
                    break
                }
            }
            if (specificConfig == null || specificConfig.default_view) return null
            this.recordAudioBtnSettings.primaryColor = specificConfig.primary_color
            if (specificConfig.title == null) specificConfig.title = config.title
            if (specificConfig.background == null) specificConfig.background = config.background
            if (specificConfig.blocks == null) specificConfig.blocks = config.blocks
            if (specificConfig.show_comment_always == null) specificConfig.show_comment_always = config.show_comment_always
            if(specificConfig.selected_count_max == null) specificConfig.selected_count_max = config.selected_count_max
            if(specificConfig.snap_picture_text == null) specificConfig.snap_picture_text = config.snap_picture_text
            if(specificConfig.subtitle == null) specificConfig.subtitle = config.subtitle
            if(specificConfig.auto_open_camera == null) specificConfig.auto_open_camera = config.auto_open_camera
            return specificConfig
        },
        getServiceLogConfig() {
            if(this.place_info == null) return null
            let config = this.place_info.service_log_config
            if (config == null) return null
            if (config.primary_color == null) config.primary_color = '#525252'
            this.recordAudioBtnSettings.primaryColor = config.primary_color
            return config
        },
        getTranslations(key) {
            let sldTranslations = this.place_info.sld_translations
            return sldTranslations[key] == null ? this.translate(key) : sldTranslations[key]
        },
        getSldIcons(icon, active) {
            console.log(`getSldIcons: ${icon}`)
            return `https://api.air-vote.com/api/sec-level-images/${icon}`
        },
        showExplainGeolocationPopup(allow, cancel, showAdditionalPopups = true) {
            this.sendLocationPopupAskedAction()
            this.explainGeolocationPopupSettings = {
                showCancelButton: true,
                onOkHandler: () => {
                    this.sendLocationPopupAllowedAction()
                    this.showGpsLoadingPopup()
                    allow()
                    if(showAdditionalPopups) {
                        this.showAdditionalPopupsIfNeeded()
                    }
                },
                onCancelHandler: () => {
                    this.sendLocationErrorAction(`error code: declined on popup `, 'declined_on_popup')
                    if(showAdditionalPopups) {
                        this.showAdditionalPopupsIfNeeded()
                    }
                    if (cancel) cancel()
                },
                okButtonText: this.translate('manageGPSAllowOKButton'),
                cancelButtonText: this.translate('manageGPSAllowCancelButton')
            }
        },
        recordAudio() {
            logAnalyticsEvent(`vs_audio_rec_clk`)
            this.sendLog('attach_audio_btn_click')
            let device = navigator.mediaDevices.getUserMedia({audio: true});
            device.then((stream) => {
                this.recorder = new MediaRecorder(stream);
                this.recordInProgress = true
                this.recordAudioBtnSettings.recordInProgressBool = true
                this.recordAction()
                this.recorder.start();
                setTimeout(() => {
                    this.recorder.stop();
                    this.recordInProgress = false
                    this.recordAudioBtnSettings.recordInProgressBool = false
                }, 60000);
            })
            .catch((er) => {
                this.showErrorModal(this.translate('need_audio_permission_error'))
            });
        },
        recordAction() {
            if (this.recordedAudio.length > 0) {
                this.recordedAudio.shift()
            }
            this.recorder.ondataavailable = (e) => {
                this.recordedAudio.push(e.data)
                let blob = new Blob(this.recordedAudio, {type: this.recorder.mimeType,});
                this.audioLink = URL.createObjectURL(blob)
                if (this.sendAllWhenRecordReady) {
                    this.onSaveComment()
                }
            };
        },
        stopRecordAudioClick() {
            logAnalyticsEvent(`vs_audio_rec_stop_clk`)
            this.sendLog('audio_record_stop_click')
            this.stopRecordAudio()
        },
        stopRecordAudio() {
            this.sendLog('audio_recorded')
            this.recordInProgress = false
            this.recordAudioBtnSettings.recordInProgressBool = false
            this.recorder.stop();
        },
        deleteAudioClick() {
            logAnalyticsEvent(`vs_audio_rec_remove_clk`)
            this.sendLog('audio_removed')
            this.recordedAudio.shift()
        },
        dinoBtnClick() {
            logAnalyticsEvent('vs_play_dino_clk')
            this.showDino()
        },
        showDino() {
            this.dinoSettings = {
                source: 'vs'
            }
        },
        updatePlacementBtnClick() {
            if(this.newPlacement != this.place_info.placement) {
                this.updatePlacementAction()
            }
        },
        async updatePlacementAction () {
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'new_placement'
                })
                let response = await this.changeQuestionPlacement({
                    questionGuid: this.place_info.uid,
                    placement: this.newPlacement
                })
                if (response) {
                    this.showErrorModal(this.translate('NewPlacementSaved'))
                    this.place_info.placement = this.newPlacement
                }
            } catch (error) {
                this.showErrorModal(this.translate('PleaseEnterCorrectPlacement'))
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'new_placement'
                })
            }
        },
        checkShowPlacementFlag() {
            return this.serviceLogMode && this.getServiceLogConfig() !== null && this.getServiceLogConfig().show_placement_edit
        },
        bottomSnapPictureBlockText() {
            let defText = 'Want to add a picture of the problem?'
            if(this.serviceLogMode) {
                return this.getServiceLogConfig() && this.getServiceLogConfig().snap_picture_text != null ? this.getServiceLogConfig().snap_picture_text : defText
            } else {
                return this.getCurrentSecondLevelDetails() && this.getCurrentSecondLevelDetails().snap_picture_text != null ? this.getCurrentSecondLevelDetails().snap_picture_text : defText
            }
        },
        showSnapPicturePopup() {
            logAnalyticsEvent(`snap_picture_popup_displayed`)
            this.sendLog('confirm_with_photo_popup_show')
            this.snapPicturePopupSettings = {
                title: this.translate('snapPicturePopupTitle'),
                onCancelHandler: () => {
                    logAnalyticsEvent(`snap_picture_popup_cancel_clicked`)
                    this.sendLog('confirm_with_photo_popup_cancel_click')
                    this.snapPicturePopupSettings = null
                },
                onSnapPictureHandler: () => {
                    logAnalyticsEvent(`snap_picture_button_clicked`)
                    this.sendLog('confirm_with_photo_popup_attach_click')
                    this.snapPicturePopupSettings = null
                    this.attachOnlyPhoto()
                },
            }
        },
    getMainScreenNoteTitle() {
                if(this.isDumpstersMode()) return this.translate('feedbackTitleDumpsters')
                return +this.rate_id === 3 ? this.translate('feedbackTitle') : +this.rate_id === 2 ? this.translate('feedbackTitleSoSo') : this.translate('feedbackTitleSad')
            },
            isDumpstersMode() {
                return this.place_info.place.uid == '4561011d-d602-4553-a04f-498e9c25c0e4' || this.place_info.place.uid == '7131122b-b2ac-4130-9f60-53a23428cb4d'
            },
            applyInitialOnLoading(show) {
                this.setProgressBarTag({show: show, tag: 'loading_vote'})
                this.hideInitialOnLoading = show
            },
            checkRateAndLinksCount() {
                return this.rate_id == 3 && (this.getPlaceLinks() && this.getPlaceLinks().length > 0)
            },
        showAdditionalPopupsIfNeeded() {
            if(this.giveaway.enabled
                && (this.giveaway.giveaway_title == 'm&k' || this.giveaway.giveaway_title == 'wasted')
                && !this.accessToken) {
                this.showGiveawayPopup()
            } else {
                this.showPublicReviewPopupIfNeeded()
            }
            // if(this.placesUidForSnapPicturePopup.has(this.place_info.place.uid)) this.showSnapPicturePopup()
            // } else {
            //     this.showPublicReviewPopupIfNeeded()
            // }
        },
        showPublicReviewPopupIfNeeded(force = false) {
            if(!this.serviceLogMode && this.checkRateAndLinksCount() && (!this.publicReviewPopupShown || force)
                && (
                    this.place_info.place.uid == '3f91c1f3-03b1-4c7d-bdb3-ef7c01a076a5' //ND Sellers
                    || this.place_info.place.uid == 'f987eaa9-e229-4080-8e9b-f63bef0316f3' //VannGo
                )
            ) {
                this.publicReviewPopupShown = true
                this.publicReviewPopupSettings = {
                    place_links: this.getPlaceLinks(),
                    onLinkClickHandler: this.openSocialLink,
                    social_subtitle: this.place_info.place.social_subtitle
                }
            }
        },
        showAutoGoogleRedirectPrompt(actionDoneCallback = null) {
            console.log(`showAutoGoogleRedirectPrompt`)
            let linkItem = null
            for (var linkIndx in this.getPlaceLinks()) {
                let link = this.getPlaceLinks()[linkIndx]
                if(link.network.alias == 'google') {
                    linkItem = link
                    break
                }
            }
            if(!linkItem) return;
            console.log(`has google link`)
            if(!this.googleAutoReviewPopupShown) {
                this.googleAutoReviewPopupSettings = {
                    link: linkItem,
                    onLinkClickHandler: (link) => {
                        this.openSocialLink(link)
                        this.googleAutoReviewPopupSettings = null
                        if(actionDoneCallback) {
                            actionDoneCallback()
                        }
                    },
                    onTimerFinishedHandler: (link) => {
                        let opened = this.openSocialLinkAuto(link)
                        if(opened) {
                            this.googleAutoReviewPopupSettings = null
                            if (actionDoneCallback) {
                                actionDoneCallback()
                            }
                        } else {
                            this.googleAutoReviewPopupSettings.showRedirectFailedMsg = true
                        }
                    },
                    social_subtitle: this.place_info.place.social_subtitle
                }
                this.$refs.gAutoReviewPopup.restartTimer()
            }
            this.googleAutoReviewPopupShown = true
        },
        onGpsFetchSuccess() {
            console.log(`onGpsFetchSuccess`)
            this.hideGpsLoadingPopup()
        },
        onGpsFetchError() {
            console.log(`onGpsFetchError`)
            this.hideGpsLoadingPopup()
        },
        hideGpsLoadingPopup() {
            console.log(`hideGpsLoadingPopup`)
            this.geolocationLoadingPopupSettings = null
        },
        showGpsLoadingPopup() {
            console.log(`showGpsLoadingPopup`)
            this.geolocationLoadingPopupSettings = {
                onCancelHandler: () => {
                    this.sendGpsLoadingPopupHideAction()
                },
            }
        },
        isServiceLogRoute() {
          return this.$route.name == 'ServiceLog'
        },
        showServiceLogLogin(hideOnClickOutside = true) {
            console.log('showServiceLogLogin from vote screen')
            this.staffLogInModalSettings = {
                show: true,
                hideOnClickOutside: hideOnClickOutside,
                question_uid: this.question_id,
                onGotUserCreds: () => {
                    this.navToServiceLog(this.question_id)
                }
            }
        },
        handleServiceLogAccessDenied() {
            this.$router.push({
                name: 'ServiceLogNoAccess',
            })
        },
        needShowWantToHearBackBlock() {
            return !this.place_info || !this.place_info.place || this.place_info.place.uid != 'e4e56956-c106-43fc-becc-b71e2bb94a89'
        },
        async onServiceInfoClick() {
            let question_id = this.$route.params.id
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'serviceLogInfo'
                })
                let response = await this.getServiceLogInfo({
                    questionGuid: question_id,
                    rate_uid: this.currentVote.uid,
                })
                if (response) {
                    this.serviceInfoModalSettings = {
                        show: true,
                        serviceInfoRatesPopup: response.data.ratesData,
                        cleaningSchedule: response.data.cleaning_schedule,
                        customerName: response.data.customer_name,
                    }
                    this.sendLog('service_history_click', {result_empty: response.data.ratesData.length == 0})
                }
            } catch (e) {
                this.showErrorModal(e.data.error.message)
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'serviceLogInfo'
                })
            }
        },

        async sendLog(action, additionalData = null) {
            await this.sendRateLog({
                question_uid: this.question_id,
                vote_uid: this.currentVote.uid,
                action: action,
                additional_data: additionalData,
            })
        },

        getWantToHearBackText() {
            if(this.serviceLogMode) {
                return this.translate('feedbackTextServiceLog')
            }else if(this.place_info && this.place_info.place.uid == '3f91c1f3-03b1-4c7d-bdb3-ef7c01a076a5'){
                return 'Participate in $50 giveaway'
            } else {
                return this.translate('feedbackText')
            }
        },
    },

}
</script>


<style>
body {
    margin: 0;
}

.pct_slide_up > div, .pct_slide_down > div {
    bottom: -50px;
    transition: bottom 0.4s ease-in-out;
}
.pct_slide_down > div {
    bottom: 0px;
}
.bottom_picture_block {
    position: fixed;
    bottom: -50px;
    background: #ffffff;
    width: 100%;
    max-width: 500px;
    display: flex;
    cursor: pointer;
}
.bottom_picture_content {
    position: fixed;
    background: #ffffff;
    height: 50px;
    width: 100%;
    max-width: 500px;
    display: flex;
    box-shadow: 0 10px 11px 10px rgba(0, 0, 0, 0.18);
    cursor: pointer;
    /*border-radius: 12px 12px 0 0;*/
}
.bottom_picture_block:hover {
    background: #f5f5f5;
}
.bottom_picture_block .bottom_picture_img {
    max-width: 30px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 2px;
}
.bottom_picture_block .lbl {
    align-self: center;
    font-size: 17px;
    width: 100%;
    padding-left: 16px;
}

.block__wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.photo-modal__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.photo-modal__image img {
    max-width: 100%;
    max-height: 250px;
}

.photo-modal__buttons {
    display: flex;
    justify-content: center;
    margin-top: 35px;
}

.photo-modal__change {
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-right: 25px;
}

.photo-modal__delete {
    width: 100%;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    color: #FFFFFF;
    background-color: #3F405C;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.preview {
    height: 50px;
    padding-top: 4px;
}

.preview img {
    max-width: 100%;
    max-height: 50px;
    padding-right: 5px;
}

.commentTextarea__wrapper {
    display: flex;
    flex-direction: column;
    padding-top: 15px;
}

.custom-modal.social-modal .primaryButton {
    margin-bottom: 8px;
    border-radius: 4px;
    width: 100%;
    border: none;
}

.custom-modal.social-modal .primaryButton.facebook-button {
    background: #1976D2;
}

.custom-modal.social-modal .primaryButton.yelp-button {
    background: #FE5022;
}

.custom-modal.social-modal .primaryButton.google-button {
    background: #5D8FF1;
}

.custom-modal.social-modal .primaryButton.tripAdvisor-button {
    background: #51B18A;
}

.custom-modal.social-modal .primaryButton.instagram-button {
    background: #E1306C;
}

.custom-modal.social-modal .primaryButton.vk-button {
    background: #4c75a3;
}

.custom-modal.social-modal .primaryButton.website-button {
    background: #ffb12b;
}

.custom-modal.social-modal .primaryButton.donate-button {
    background: #00a99e;
}

.custom-modal.social-modal .primaryButton.adopt-button {
    background: #9d1c20;
}

.close-icon__wrapper {
    display: flex;
    justify-content: flex-end;
}

.feedbackCheckbox-wrapper {
    display: flex;
    align-items: center;
}

.commentTextarea {
    /*margin-top: 4px;*/
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    padding-right: 12px;
}

.feedback__input {
    border: none;
    border-bottom: 2px solid #3F405C;
    background-color: #ffffff;
    border-radius: 2px;
    padding: 5px 5px 6px 12px;
    font-size: 16px;
    width: 100%;
}

.feedback__input:focus {
    outline: none;
    border: none;
    border-bottom: 2px solid #3F405C;
}

.form__input {
    border: none;
    border-bottom: 2px solid #3F405C;
    -webkit-appearance: none;
    border-radius: 0;
    font-size: 16px;
}
.form__input.conference {
    font-size: 14px !important;
    height: 45px !important;
    min-height: 30px !important;
    max-height: 45px !important;
}

.small .form__input {
    padding-right: 116px;
    padding-left: 8px;
}

.upInputs textarea {
    resize: none;
    height: 30px;
    min-height: 30px;
    overflow: hidden;
    padding-bottom: 0;
}

.form__input:focus {
    outline: none;
    border: none;
    border-bottom: 2px solid #3F405C;
}

.form__input:focus ~ .form__label {
    top: -20px;
    font-size: 16px;
}

.form__label {
    pointer-events: none;
    transition: .3s;
    opacity: 0.7;
    z-index: 1;
}


.comment-modal__btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 4px;
}

.commentModalCancel-btn {
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
}

.commentModalSubmit-btn {
    padding: 8px;
    width: 100%;
    background: #ffffff;
    border-radius: 6px;
    border: 2px solid #3F405C;
    color: #3F405C;
    margin-bottom: 8px;
    font-size: 16px;
    cursor: pointer;
}

.footer-modal__btn {
    display: flex;
    flex-direction: column-reverse;
}

.md-count:after {
    display: inline-block;
    margin-left: 8px;
    content: 'character used'
}

.uk .md-count:after {
    content: 'символів використано'
}

.ru .md-count:after {
    content: 'символов использовано'
}

.close-icon {
    position: static;
    cursor: pointer;
    width: 28px;
    height: 28px;
    /*background: url(../assets/icons/ic_close_white.svg) 50% no-repeat;*/
}

.modal-footer {
    border: none;
    justify-content: center;
}

.modal-header {
    border: none;
    justify-content: flex-end;
}

.btn {
    border: none;
    font-weight: 700;
    outline: none;
}

.note-title {
    font-size: 18px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    margin: 0 0 5px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.note-description {
    font-size: 14px;
    line-height: 20px;
    margin: 0px 15px 12px;
    /*width: 100%;*/
    font-weight: 400;
    text-align: center;
}

.note-icon-wrap {
    text-align: center;
    margin-bottom: 10px;
}

.note-icon {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: url('../assets/icons/ic_comment_modal.svg') 50% no-repeat;
}

.socialReviewBtnFlow {
    width: 100%;
    display: flex;
    justify-content: center;
}

.feedback-input {
    display: flex;
    margin-top: 10px;
    margin-bottom: 4px;
}

.feedback-input input {
    background-color: #F3F3F3;
    padding: 5px 5px 6px 0px;
}

.feedback-buttons__wrapper {
    display: flex;
    align-items: center;
}

.feedback-buttons {
    display: flex;
}

.feedback-buttons__google {
    background: #DD4B39;
    border-radius: 6px;
    text-align: center;
    margin-right: 8px;
    width: 40px;
    height: 40px;
    text-align: center;
    cursor: pointer;
}

.feedback-buttons__facebook {
    text-align: center;
    background: #1976D2;
    border-radius: 6px;
    width: 40px;
    height: 40px;
    margin-right: 8px;
    text-align: center;
    cursor: pointer;
}

.feedback-buttons__google img {
    padding-top: 8px;
}

.feedback-buttons__facebook img {
    padding-top: 8px;
}

.feedback-buttons__wrapper span {
    margin-right: 8px;
}

@media screen and (max-width: 768px) {
    .custom-modal .modal-footer {
        flex-direction: column-reverse;
    }

    .custom-modal .btn {
        margin: 0;
    }

    .custom-modal .btn.btn-primary {
        margin-bottom: 8px;
        border: none;
    }
}

@media screen and (max-width: 321px) {
    .feedback-buttons__wrapper {
        flex-direction: column;
    }

    .feedback-input {
        flex-direction: column;
    }
}

.md-textarea {
    font-size: 16px !important;
}

.feedbackCheckbox-wrapper input {
    width: 20px !important;
    height: 20px !important;
    margin-left: 0;
}
.feedbackCheckbox-wrapper svg {
    width: 27px;
    height: 27px;
}

.footer-link {
    white-space: pre-line;
    margin-bottom: 8px;
    margin-top: 4px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #2F2F2F;
    text-align: center;
    line-height: 14px;
    width: 100%;
    outline: none;
    text-decoration: none;
    cursor: pointer;
    display: none;
}

.footer-link:hover {
    color: #2f2f2f;
    outline: none;
    text-decoration: none;
}

.socialReview-btn {
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    background-color: #ffffff;
    margin-top: 8px;
    text-align: center;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    height: 42px;
    color: #3F405C;
}

.socialReviewWrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.socialReview__block {
    display: flex;
    width: 100%;
    max-width: 380px;
    padding-left: 24px;
    padding-right: 24px;
    flex-direction: column;
    align-items: center;
}

.block-btn__wrapper {
    margin-bottom: 8px;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
}

.block-btn__wrapper.giveaway {
    margin-bottom: 0;
}

.main_giveaway {
    width: 100%;
}

.block-btn img {
    margin-right: 15px;
}

.socialReview-btn-text {
    display: flex;
    align-self: center;
}

.success-message {
    margin-top: 8px;
}

.success-text {
    font-size: 17px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 5px;
}

.success-text.m-k {
    padding-left: 16px;
    padding-right: 16px;
}


.comment-wrap {
    width: min-content;
    background: white;
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
    margin-top: 16px;
    border-radius: 12px;
    max-width: 372px;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
}

.face-rate .comment-wrap {
    box-shadow: none;
}

.comment-modal__btn-content {
    display: flex;
    align-items: center;
    justify-content: center;
}

.bottom-button-group button {
    margin-top: 8px;
}

.bottom-button-group {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 24px;
}

.comment-icon {
    display: inline-block;
    margin-right: 6px;
}

.question {
    display: flex;
    align-items: center;
    text-align: center;
}


.top-block {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo {
    /*margin-top: 70px;*/
    margin-top: 16px;
    text-align: center;
    display: none;
}

.place {
    margin-top: 16px;
    margin-bottom: 16px;
}

.place_img {
    width: 54px;
    height: 54px;
    margin: 0 auto;
    box-sizing: border-box;
    border-radius: 50%;
    filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.293679));
    position: relative;
    z-index: -1;
}

.place_img img {
    min-width: 48px;
    min-height: 48px;
    margin: 0 auto;
    border-radius: 50%;
    display: block;
    width: 100%;
    height: 100%;
}

.question {
    text-align: center;
    font-size: 15px;
    line-height: 18px;
    font-weight: 700;
    margin-left: 20px;
    margin-right: 20px;
    max-width: 360px;
}

.place_name {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #6D6D6D;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 8px;
    display: none;
}

.feedback-text {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    padding-left: 5px;
    -webkit-line-clamp: 1;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}

.feedback-wrapper {
    background: #F3F3F3;
    border-radius: 4px;
    padding: 8px;
    display: flex;
    justify-content: start;
    align-items: start;
    flex-direction: column;
    margin-top: 8px;
    margin-bottom: 10px;
}

.feedback-wrapper-spacer {

}

.block-btn {
    display: flex;
    justify-content: center;
    max-height: 42px;
    min-height: 42px;
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    align-items: center;
    color: #3F405C;
}

.block-btn.giveaway {
    color: #3F405C;
    /*background: url(../assets/icons/confetti.svg) 50% no-repeat;*/
    height: 60px !important;
    max-height: 60px !important;
    min-height: 60px !important;
    background-color: #FF8C00;
    display: flex;
    flex-direction: column;
    cursor: pointer;
}
.main_giveaway .block-btn.giveaway {
    margin-left: 24px;
    margin-right: 24px;
    margin-bottom: 24px;
}
.block-btn.giveaway.m_and_k {
    background-color: #313131;
    color: white;
    border: 2px solid white !important;
}

.block-btn.giveaway.active {
    background-color: #FF8C00 !important;
}
.block-btn.giveaway.m_and_k.active {
    background-color: #313131 !important;
}

.block-title {
    text-align: center;
    margin-bottom: 8px;
}

.face-rate .comment-wrap button {
    margin-top: 0;
    margin-bottom: 0;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    min-height: 42px;
    padding: 0;
}

.wrapper {
    background: rgba(255, 157, 0, 0.31);
    width: 100%;
    min-height: 100vh;
    max-width: 500px;
    box-shadow: 0 10px 11px 0 rgba(0, 0, 0, 0.11);
    position: absolute;
    margin: auto;
    border-radius: 4px;
    padding-bottom: 30px;
    top: 0;
    left: 0;
    right: 0;
}

.wrapper.red {
    background: rgba(181, 23, 0, 0.3);
}

.wrapper.red.active {
    background: #00ddff;
}

.header {
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    min-height: 70px;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.header__wrapper {
    width: 100%;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 15px;
    min-height: 38px;
    display: flex;
    flex-direction: column;
    justify-content: space-around
}

.rectangle-wrapper {
    margin-left: 16px;
    margin-right: 16px;
    width: 100%;
}

.rectangle {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    justify-content: center;
    height: 100%;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    aspect-ratio: 1;
    max-width: 100%;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
}

.rectangle-noicon {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    height: 107px;
    justify-content: center;
}

.rectangle.check {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 9px;
    top: 9px;
    box-shadow: none;
}

.rectangle-noicon.check {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 9px;
    top: 0;
    min-height: 24px;
}

.rectangle-wrapper.left {
    margin-right: 8px;
}

.rectangle-wrapper.right {
    margin-left: 8px;
}

.rectangle.active {
    padding: 0;
}

.rectangle-noicon.active {
    border: 3px solid #000000;
    padding: 0;
}

.rectangle_img {
    max-width: 85px;
    max-height: 85px;
    margin-bottom: 18px;
}
.rect_btn_img {
    max-width: 60px;
    max-height: 60px;
    margin-bottom: 10px;
}

.rect_small_ic {
    max-width: 40px;
    position: absolute;
    top: 4px;
    left: 6px;
}

.rect_close {
    max-width: 20px;
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 12px;
    padding-right: 12px;
    padding-left: 8px;
    padding-bottom: 8px;
}
.rect_close_back {
    width: 32px;
    height: 32px;
    position: absolute;
    aspect-ratio: 1;
    top: 6px;
    right: 6px;
    /*background: rgba(185, 94, 94, 0.40);*/
    background: rgb(131, 131, 131, 0.40);
    border-radius: 4px;
}

.rectangle-text {
    position: absolute;
    font-weight: bold;
    font-size: 17px;
    line-height: 22px;
    padding-top: 5px;
    padding-right: 10px;
    padding-bottom: 5px;
    margin-bottom: 3px;
    padding-left: 10px;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 96%;
    color: #424242;
    bottom: 0;
    border-radius: 4px;
}
.rectangle-text.active {
    color: #ffffff;
}

.rectangle-text__noicon {
    font-weight: bold;
    font-size: 19px;
    line-height: 24px;
    padding: 5px 5px 5px;
    text-align: center;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
    max-width: 100%;
}

.main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 50px;
}

.content__wrapper {
    display: flex;
    justify-content: space-around;
    padding-top: 16px;
    width: 100%;
}

.giveaway-text__wrapper {
    text-align: center;
}

.audio_wrapper {
    width: 100%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
}

audio {
    width: 90%;
}

.audio_delete {
    margin-left: 10px;
    cursor: pointer;
    margin-top: 5px;
}
.header-title {
    margin-left: 70px;
    margin-right: 70px;
    white-space: pre-wrap;
    font-size: 18px;
}
.sld_subtitle {
    margin-left: 24px;
    margin-right: 24px;
    padding-bottom: 12px;
    text-align: center;
    font-size: 15px;
    white-space: pre-wrap;
    font-weight: 600;
    line-height: 18px;
}
.service_log_info {
    background-color: unset;
    color: white;
    cursor: pointer;
    margin-top: 20px;
    position: fixed;
    bottom: 0;
    background: #3F405C;
    width: 100%;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    max-width: 500px;
}
.service_log_info_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 13px;
    padding-bottom: 13px;
}
.service_log_info_wrapper img {
    margin-right: 14px;
}
.service_log_info__text {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
}
.service_log_info-btn {
    border: 2px solid #3F405C;
    border-radius: 6px;
    padding: 9px 0;
    cursor: pointer;
    width: 100%;
    max-width: 376px !important;
    margin-bottom: 8px;
}
.service_log_info-btn_wrapper {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3F405C;
}
.service_log_info-btn__text {
    margin-left: 8px;
}

@media screen and (max-height: 550px) {
    /*todo real 550, test 666| less than iphone 6/7/8*/
    .place {
        margin-top: 8px;
        margin-bottom: 8px;
    }

    .place_img {
        width: 48px;
        height: 48px;
    }

    .push_rate {
        margin-top: 8px !important;
    }

    .note-title {
        font-size: 16px;
    }

    .question {
        font-size: 14px;
        line-height: 16px;
    }

    .success-text {
        font-size: 14px;
    }

    .success-message {
        margin-top: 0;
    }

    .block-title {
        margin-bottom: 6px;
    }

    .socialReview-btn {
        height: 36px;
    }

    .anon-comment__btn-content {
        height: 36px !important;
    }

    .block-btn {
        max-height: 36px;
        min-height: 36px;
    }

    .socialReview__block {
        margin-top: 10px;
    }

    .footer-link {
        display: none;
    }

    .block-btn__wrapper.giveaway {
        margin-bottom: 15px !important;
    }

    .rectangle_img {
        max-width: 85px;
        max-height: 85px;
    }
    .rect_btn_img {
        max-width: 50px;
        max-height: 50px;
    }
    .rectangle-noicon {
        height: 95px;
    }
}

@media screen and (min-height: 621px) {
    /*todo real 621, test 735| iphone 6/7/8 Plus and bigger */
    .stretched .place {
        margin-top: 24px;
        margin-bottom: 24px;
    }

    .stretched .place_name {
        display: block;
    }

    .place_img {
        width: 60px;
        height: 60px;
    }

    .footer-link {
        display: none;
    }

    .comment-modal__btn {
        margin-top: 4px;
    }

    .stretched .success-message {
        margin-top: 16px;
    }

    .rectangle_img {
        max-width: 115px;
        max-height: 115px;
    }
    .rect_btn_img {
        max-width: 80px;
        max-height: 80px;
    }
    .rectangle-text__noicon {
        font-size: 23px;
    }
    .rectangle-noicon {
        height: 145px;
    }
    .bottom-button-group {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        margin-top: 32px;
    }
}

@media screen and (max-height: 631px) {
    /*todo real 631, test 745 */
    .place {
        margin-top: 16px;
        margin-bottom: 16px;
    }

    .compact .footer-link {
        display: none;
    }

    .comment-wrap {
        margin-bottom: 8px;
    }

    .socialReview__block {
        margin-bottom: 8px;
    }

    .footer-link {
        display: none;
    }
    .rectangle {
        aspect-ratio: 1.2;
    }
}

@media screen and (min-height: 696px) {
    /*todo real 696, test 810| iphone X + larger*/
    .place {
        margin-top: 24px;
        margin-bottom: 18px;
    }

    .place_name {
        display: block;
    }

    .place_img {
        width: 80px;
        height: 80px;
    }

    .feedback-wrapper {
        margin-top: 12px;
        margin-bottom: 12px;
    }

    .commentTextarea.upInputs {
        /*margin-top: 12px;*/
    }

    .commentTextarea {
        /*margin-top: 8px;*/
    }

    .footer-link {
        margin-bottom: 12px;
        margin-top: 16px;
        display: block;
    }

    .comment-modal__btn {
        margin-top: 16px;
    }

    .success-text {
        font-size: 18px;
    }

    .question {
        font-size: 18px;
        line-height: 22px;
        -webkit-line-clamp: 2;
        overflow: hidden;
        -webkit-box-orient: vertical;
        display: -webkit-box;
    }

    .push_rate ul li a {
        width: 63px !important;
        height: 63px !important;
    }

    .push_rate ul li img {
        width: 60px !important;
        height: 60px !important;
    }
}

@media screen and (min-height: 780px) {
    /*todo real 780, test 890| iphone 11 Pro + larger*/
    .footer-link {
        display: block;
    }

    .place {
        margin-top: 44px;
        margin-bottom: 36px;
    }

    .success-message {
        margin-top: 16px;
    }

    .comment-modal__btn {
        margin-top: 24px;
    }

    .commentTextarea.upInputs {
        /*margin-top: 16px;*/
    }

    .commentTextarea {
        /*margin-top: 12px;*/
    }
}

@media screen and (max-width: 376px) {
    .comment-wrap {
        max-width: 325px;
    }

    .rectangle-text {
        padding-bottom: 1px;
        padding-top: 1px;
        margin-bottom: 3px;
        font-size: 15px;
    }
    .service_log_info-btn {
        max-width: 327px !important;
    }
    .bottom_picture_block .lbl {
        font-size: 15px;
    }
}
@media screen and (max-width: 340px) {
    .bottom_picture_block .lbl {
        font-size: 13px;
    }
    .rectangle-text {
        padding-bottom: 0px;
        margin-bottom: 2px;
        padding-top: 0px;
        padding-right: 6px;
        padding-left: 6px;
    }
}

@media screen and (max-width: 321px) {
    .comment-wrap {
        max-width: 270px;
    }

    .rectangle {
        height: 100%;
    }

    .rectangle-noicon {
        height: 100px;
    }

    .rectangle.check {
        width: 25px;
        height: 30px;
        position: absolute;
        left: 5px;
    }

    .rectangle-noicon.check {
        width: 25px;
        height: 30px;
        position: absolute;
        left: 5px;
    }

    .rectangle-text__noicon {
        font-size: 18px;
        line-height: 19px;

    }
    .update_location-btn {
        margin-top: 12px;
        max-width: 100px;
        text-align: center;
    }
    .service_log_info-btn {
        max-width: 268px !important;
    }

}

</style>


<style scoped>
.anon-comment__btn, .service_info_btn {
    text-align: center;
    width: 100%;
    max-width: 380px;
    margin-bottom: 8px;
}

.anon-comment__btn-content, .service_info_btn__content {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: #3F405C;
    justify-content: center;
    background-color: white;
    border: 2px solid #3F405C;
    border-radius: 6px;
    height: 42px;
}

.anon-comment__btn-content img, .service_info_btn__content img {
    margin-right: 4px;
}

.anon-comment__btn-content .ic_photo {
    margin-right: 8px;
}

.vote-screen {
    display: flex;
    flex-direction: row;
}

.face-rate {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    max-height: 900px;
    max-width: 500px;
    margin: auto;
    border-radius: 4px;
}

button.primaryButton.reverse {
    color: #3F405C;
    border: 2px solid #3F405C;
}

.md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
    min-height: 45px;
    border-bottom: 2px solid #3F405C;
    border-radius: 1px;
    font-weight: 600;
    padding-left: 0;

}

.md-field.md-has-textarea:not(.md-autogrow) label {
    top: 45px;
    left: 0px;
    font-size: 14px;
    font-weight: normal;
    color: #2F2F2F;
}

.md-field.md-has-textarea:not(.md-autogrow).md-has-value label {
    top: 15px;
}

.md-field.md-has-textarea:not(.md-autogrow).md-focused label, .md-field.md-has-textarea:not(.md-autogrow).md-has-value label {
    top: 10px;
}

.custom-control-label {
    padding-top: 4px;
}

.custom-modal .btn.btn-primary {
    background-color: #3F405C;
}

.custom-modal .btn {
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    margin-right: 5px;
    width: 100%;
    font-size: 14px;
    font-weight: 700;
    padding: 10px 12px;
}

.custom-control {
    line-height: 28px;
}

label {
    margin-bottom: 0;
}

.feedback-input {
    width: 100%;
    height: 100%;
}

.md-field:after {
    height: 2px;
}

.md-field.md-theme-default:after {
    background-color: #3F405C;
    border-radius: 1px;
}

.md-field label {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #6D6D6D;
}

.md-helper-text {
    font-weight: normal;
    font-size: 14px !important;
    line-height: 20px;
    color: #2f2f2f;
    opacity: 0.7;

}

.push_rate {
    margin-top: 12px;
    display: flex;
}

.push_rate ul {
    margin: 0.2em auto;
}

.push_rate ul li {
    margin: 0;
}

.push_rate ul li.active.cool {
    box-shadow: inset 0 0 0 0.35em #209400
}

.push_rate ul li.active.soso {
    box-shadow: inset 0 0 0 0.35em #ffc800
}

.push_rate ul li.active.meh {
    box-shadow: inset 0 0 0 0.35em #e01300
}

.push_rate ul li a {
    padding-top: 8px;
    padding-left: 4px;
    padding-right: 4px;
    padding-bottom: 0px;
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.push_rate ul li img {
    width: 55px;
    height: 55px;
}

.submit button {
    margin-bottom: 15px;
}

.list-view span {
    margin-right: .4em;
    line-height: normal;
}

.md-field {
    min-height: 53px;
}

.commentTextarea.upInputs {

}

.comment_wrapper {
    display: grid;
}

.comment_wrapper.small {

}

.comment_wrapper.big {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    visibility: hidden;
    margin-left: 6px;
    margin-right: 130px;
}

.comment_wrapper.big textarea {
    resize: none;
    max-height: 200px;
}

.comment_btn__wrapper {
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.comment_btn__wrapper.send {
    width: 36px;
    height: 36px;
    position: absolute;
    right: 12px;
    bottom: 4px;
}

.comment_btn__wrapper.photo {
    position: absolute;
    right: 56px;
    bottom: 4px;
    cursor: pointer;
}

.comment_btn__wrapper.audio {
    position: absolute;
    right: 90px;
    bottom: 5px;
    cursor: pointer;
}

.comment_btn__wrapper.audio img {
    width: 20px;
    height: 20px;
}

.comment_btn__wrapper.audio-stop {
    width: 20px;
    height: 20px;
    font-size: 0;
    background-color: red;
    border: 0;
    border-radius: 35px;
    outline: none;
    position: absolute;
    right: 98px;
    bottom: 12px;
    cursor: pointer;
    display: none;
}

.comment_btn__wrapper.audio-stop.active {
    display: block;
    animation-name: pulse;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse {
    0% {
        box-shadow: 0px 0px 5px 0px rgba(173, 0, 0, .3);
    }
    65% {
        box-shadow: 0px 0px 5px 10px rgba(173, 0, 0, .3);
    }
    90% {
        box-shadow: 0px 0px 5px 10px rgba(173, 0, 0, 0);
    }
}

.comment_btn__wrapper img {
    width: 30px;
    height: 30px;
}

.big .comment_btn__wrapper.photo {
}

.loading_progress {
    background: rgba(47, 47, 47, 0.16);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
}

.loader {
    border: 8px solid #f3f3f3; /* Light grey */
    border-top: 8px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 2s linear infinite;
}
.location {
    margin-top: 30px;
    padding: 0 16px 0 16px;
}
.location_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.update_location-btn.disabled {
    opacity: 0.5;
}
.update_location-btn {
    cursor: pointer;
    padding: 10px;
    background-color: #3F405C;
    color: white;
    border-radius: 6px;
    margin-left: 30px;
}
.placement {
    max-width: 270px;
    width: 100%;
}
.placement label {
    position: absolute;
    top: 55px;
    font-size: 15px;
}
.placement input {
    border: none;
    border-bottom: 2px solid;
    width: 100%;
    padding: 10px 10px 10px 0;
    color: black;
    background-color: rgb(0, 0, 0, 0);
    position: relative;
    font-size: 16px;
    border-radius: 0;
}
.placement input:focus {
    outline: none;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes rotate_loader {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}


@-webkit-keyframes rotate_loader {
    from {
        -webkit-transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
    }
}

.progress_loader_wrapper {
    position: absolute;
    padding: 5px;
    border-radius: 50%;
    background: #36BC00;
}
.progress_loader {
    width: 20px;
    height: 20px;
    border: solid 3px #ffffff;
    border-radius: 50%;
    border-right-color: transparent;
    border-bottom-color: transparent;
    -webkit-transition: all 0.5s ease-in;
    -webkit-animation-name: rotate_loader;
    -webkit-animation-duration: 1.0s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;

    transition: all 0.5s ease-in;
    animation-name: rotate_loader;
    animation-duration: 1.0s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

</style>
